/**
 * Settings + transactions copy merged into locale modules that otherwise
 * fall back to English for these keys.
 */
export const panelSettingsTransactionsByLang = {
  fr: {
    'user.page.transactions': 'Transactions',
    'common.next': 'Suivant',
    'common.previous': 'Précédent',
    'user.transactions.sectionTitle': 'Historique des transactions',
    'user.transactions.loading': 'Chargement des transactions…',
    'user.transactions.emptyTitle': 'Aucune transaction',
    'user.transactions.emptyHint': 'Essayez d’ajuster vos filtres',
    'user.transactions.col.date': 'Date et heure',
    'user.transactions.col.type': 'Type',
    'user.transactions.col.description': 'Description',
    'user.transactions.col.amount': 'Montant',
    'user.transactions.col.status': 'Statut',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'Affichage de {{from}}–{{to}} sur {{total}} transactions',
    'user.transactions.filter.from': 'Du',
    'user.transactions.filter.to': 'Au',
    'user.transactions.filter.searchPlaceholder': 'Rechercher TXID ou description…',
    'user.transactions.filter.all': 'Tous',
    'user.transactions.filter.deposit': 'Dépôt',
    'user.transactions.filter.withdrawal': 'Retrait',
    'user.transactions.filter.investment': 'Investissement',
    'user.transactions.filter.evoucher': 'E-bon',
    'user.transactions.filter.referral': 'Parrainage',
    'user.transactions.filter.stopLoss': 'Stop-Loss',
    'user.transactions.badge.deposit': 'Dépôt',
    'user.transactions.badge.withdrawal': 'Retrait',
    'user.transactions.badge.investment': 'Investissement',
    'user.transactions.badge.e-voucher': 'E-bon',
    'user.transactions.badge.referral': 'Parrainage',
    'user.transactions.badge.bonus': 'Bonus',
    'user.transactions.badge.stop-loss': 'Stop-Loss',
    'user.transactions.badge.completed': 'Terminé',
    'user.transactions.badge.active': 'Actif',
    'user.transactions.badge.pending': 'En attente',
    'user.transactions.badge.confirming': 'Confirmation',
    'user.transactions.badge.approved': 'Approuvé',
    'user.transactions.badge.cancelled': 'Annulé',
    'user.transactions.badge.rejected': 'Rejeté',
    'user.transactions.badge.failed': 'Échoué',
    'user.transactions.exportCsv': 'Exporter CSV',
    'user.transactions.exportCsvTitle': 'Exporter au format CSV',
    'user.transactions.exportNoData': 'Aucune donnée à exporter',
  },

  de: {
    'user.settings.intro':
      'Aktualisieren Sie Profil, Sicherheit und Einstellungen für dieses Konto.',
    'agent.settings.intro':
      'Aktualisieren Sie Profil, Sicherheit und Anzeigeoptionen für dieses Agentenkonto.',
    'settings.tab.profile': 'Profil',
    'settings.tab.security': 'Sicherheit',
    'settings.tab.preferences': 'Einstellungen',
    'settings.shell.loading': 'Einstellungen werden geladen…',
    'settings.shell.errorTitle': 'Einstellungen konnten nicht geladen werden',
    'settings.shell.errorHint':
      'Prüfen Sie Ihre Verbindung oder melden Sie sich erneut an, wenn die Sitzung abgelaufen ist.',
    'settings.shell.tryAgain': 'Erneut versuchen',
    'settings.shell.sessionExpired': 'Sitzung abgelaufen — bitte erneut anmelden',
    'settings.shell.loadProfileFailed': 'Profil konnte nicht geladen werden',
    'settings.shell.invalidProfile': 'Ungültige Profilantwort',
    'settings.shell.saveFailed': 'Speichern fehlgeschlagen',
    'settings.notifications.sectionTitle': 'Benachrichtigungen',
    'settings.notifications.toggle.emailNotifications.label': 'E-Mail-Benachrichtigungen',
    'settings.notifications.toggle.emailNotifications.desc': 'Updates per E-Mail erhalten',
    'settings.notifications.toggle.depositAlerts.label': 'Einzahlungswarnungen',
    'settings.notifications.toggle.depositAlerts.desc': 'Benachrichtigung bei bestätigten Einzahlungen',
    'settings.notifications.toggle.withdrawalAlerts.label': 'Auszahlungswarnungen',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'Benachrichtigung bei Auszahlungsstatus',
    'settings.notifications.toggle.investmentUpdates.label': 'Investitionsupdates',
    'settings.notifications.toggle.investmentUpdates.desc':
      'Monatliche Zinsen und Planhinweise',
    'settings.notifications.toggle.referralAlerts.label': 'Empfehlungswarnungen',
    'settings.notifications.toggle.referralAlerts.desc':
      'Benachrichtigungen zu Empfehlungsaktivität',
    'user.settings.preferences.summary':
      '{{enabled}} von {{total}} E-Mail-Warnungen sind aktiv. Öffnen Sie den Dialog für Einzahlung, Auszahlung und weitere Einstellungen.',
    'user.settings.preferences.manage': 'Benachrichtigungen verwalten',
    'user.settings.preferences.modalTitle': 'Benachrichtigungseinstellungen',
    'user.settings.preferences.modalHint':
      'Wählen Sie, welche E-Mails wir senden. Sie können dies jederzeit ändern.',
    'user.settings.preferences.toastNotificationsSaved': 'Benachrichtigungen gespeichert',
    'user.settings.preferences.saveNotifications': 'Benachrichtigungen speichern',
    'settings.preferences.toastSaved': 'Einstellungen gespeichert',
    'settings.security.recoveryTitle': 'Wiederherstellungsphrase',
    'settings.security.recoveryBefore':
      'Ihre 12-Wort-Phrase wurde nur einmal bei der Kontoerstellung angezeigt. Sie liegt nicht im Klartext vor und kann hier nicht angezeigt werden. Zum Zurücksetzen des Passworts nutzen Sie',
    'settings.security.recoveryAfter': 'mit Ihrer gespeicherten Phrase.',
    'settings.security.forgotPasswordLink': 'Passwort vergessen',
    'settings.password.title': 'Passwort ändern',
    'settings.password.current': 'Aktuelles Passwort',
    'settings.password.new': 'Neues Passwort',
    'settings.password.confirm': 'Passwort bestätigen',
    'settings.password.show': 'Anzeigen',
    'settings.password.hide': 'Ausblenden',
    'settings.password.match': 'Passwörter stimmen überein',
    'settings.password.noMatch': 'Passwörter stimmen nicht überein',
    'settings.password.errMinLen': 'Mindestens 8 Zeichen erforderlich',
    'settings.password.errSameAsCurrent': 'Neues Passwort muss sich vom aktuellen unterscheiden',
    'settings.password.errMismatch': 'Passwörter stimmen nicht überein',
    'settings.password.toastUpdateFailed': 'Passwort konnte nicht aktualisiert werden',
    'settings.password.toastUpdated': 'Passwort erfolgreich aktualisiert',
    'settings.password.submit': 'Passwort aktualisieren',
    'settings.password.updating': 'Wird aktualisiert…',
    'settings.profile.cropPhotoAria': 'Foto zum Zuschneiden wählen',
    'settings.profile.addNameHint': 'Tragen Sie unten Ihren vollständigen Namen ein.',
    'settings.profile.activeAccount': 'Aktives Konto',
    'settings.profile.choosePhoto': 'Foto wählen',
    'settings.profile.working': 'Wird bearbeitet…',
    'settings.profile.removePhoto': 'Foto entfernen',
    'settings.profile.infoTitle': 'Profilinformationen',
    'settings.profile.fullName': 'Vollständiger Name',
    'settings.profile.placeholderFullName': 'Ihr vollständiger Name',
    'settings.profile.email': 'E-Mail',
    'settings.profile.emailLockedHint': 'E-Mail kann nicht geändert werden',
    'settings.profile.phone': 'Telefonnummer',
    'settings.profile.phonePlaceholder': '+49… oder nur Ziffern',
    'settings.profile.address': 'Adresse',
    'settings.profile.username': 'Benutzername',
    'settings.profile.saveChanges': 'Änderungen speichern',
    'settings.profile.nameRequired': 'Vollständiger Name ist erforderlich',
    'settings.profile.updatedToast': 'Profil erfolgreich aktualisiert',
    'settings.profile.uploadFailed': 'Upload fehlgeschlagen',
    'settings.profile.removeFailed': 'Foto konnte nicht entfernt werden',
    'settings.profile.photoUpdated': 'Foto aktualisiert',
    'settings.profile.photoRemoved': 'Foto entfernt',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'Profilfoto zuschneiden',
    'settings.avatarCrop.hint':
      'Ziehen zum Verschieben, Schieberegler zum Zoomen. Das Foto wird quadratisch gespeichert.',
    'settings.avatarCrop.zoom': 'Zoom',
    'settings.avatarCrop.zoomAria': 'Zuschneide-Zoom',
    'settings.avatarCrop.savePhoto': 'Foto speichern',
    'settings.avatarCrop.uploading': 'Wird hochgeladen…',
    'settings.avatarCrop.toastWaitLoad': 'Warten Sie, bis das Bild geladen ist, und versuchen Sie es erneut.',
    'settings.avatarCrop.toastCropFail':
      'Dieses Bild konnte nicht zugeschnitten werden. Versuchen Sie JPEG oder PNG.',
    'settings.currency': 'Währung',
    'settings.selectCurrency': 'Währung wählen',
    'settings.languagePlaceholder': 'Sprache wählen',
    'common.cancel': 'Abbrechen',
    'common.next': 'Weiter',
    'common.previous': 'Zurück',
    'user.page.transactions': 'Transaktionen',
    'user.transactions.sectionTitle': 'Transaktionsverlauf',
    'user.transactions.loading': 'Transaktionen werden geladen…',
    'user.transactions.emptyTitle': 'Keine Transaktionen',
    'user.transactions.emptyHint': 'Passen Sie Ihre Filter an',
    'user.transactions.col.date': 'Datum und Uhrzeit',
    'user.transactions.col.type': 'Typ',
    'user.transactions.col.description': 'Beschreibung',
    'user.transactions.col.amount': 'Betrag',
    'user.transactions.col.status': 'Status',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '{{from}}–{{to}} von {{total}} Transaktionen',
    'user.transactions.filter.from': 'Von',
    'user.transactions.filter.to': 'Bis',
    'user.transactions.filter.searchPlaceholder': 'TXID oder Beschreibung suchen…',
    'user.transactions.filter.all': 'Alle',
    'user.transactions.filter.deposit': 'Einzahlung',
    'user.transactions.filter.withdrawal': 'Auszahlung',
    'user.transactions.filter.investment': 'Investition',
    'user.transactions.filter.evoucher': 'E-Gutschein',
    'user.transactions.filter.referral': 'Empfehlung',
    'user.transactions.filter.stopLoss': 'Stop-Loss',
    'user.transactions.badge.deposit': 'Einzahlung',
    'user.transactions.badge.withdrawal': 'Auszahlung',
    'user.transactions.badge.investment': 'Investition',
    'user.transactions.badge.e-voucher': 'E-Gutschein',
    'user.transactions.badge.referral': 'Empfehlung',
    'user.transactions.badge.bonus': 'Bonus',
    'user.transactions.badge.stop-loss': 'Stop-Loss',
    'user.transactions.badge.completed': 'Abgeschlossen',
    'user.transactions.badge.active': 'Aktiv',
    'user.transactions.badge.pending': 'Ausstehend',
    'user.transactions.badge.confirming': 'Wird bestätigt',
    'user.transactions.badge.approved': 'Genehmigt',
    'user.transactions.badge.cancelled': 'Storniert',
    'user.transactions.badge.rejected': 'Abgelehnt',
    'user.transactions.badge.failed': 'Fehlgeschlagen',
    'user.transactions.exportCsv': 'CSV exportieren',
    'user.transactions.exportCsvTitle': 'Als CSV exportieren',
    'user.transactions.exportNoData': 'Keine Daten zum Exportieren',
  },

  es: {
    'user.settings.intro':
      'Actualiza tu perfil, la seguridad y las preferencias de esta cuenta.',
    'agent.settings.intro':
      'Actualiza tu perfil, la seguridad y las preferencias de visualización de esta cuenta de agente.',
    'settings.tab.profile': 'Perfil',
    'settings.tab.security': 'Seguridad',
    'settings.tab.preferences': 'Preferencias',
    'settings.shell.loading': 'Cargando ajustes…',
    'settings.shell.errorTitle': 'No se pudieron cargar los ajustes',
    'settings.shell.errorHint':
      'Comprueba tu conexión o cierra sesión y vuelve a entrar si la sesión expiró.',
    'settings.shell.tryAgain': 'Reintentar',
    'settings.shell.sessionExpired': 'Sesión expirada — inicia sesión de nuevo',
    'settings.shell.loadProfileFailed': 'No se pudo cargar el perfil',
    'settings.shell.invalidProfile': 'Respuesta de perfil no válida',
    'settings.shell.saveFailed': 'Error al guardar',
    'settings.notifications.sectionTitle': 'Notificaciones',
    'settings.notifications.toggle.emailNotifications.label': 'Notificaciones por correo',
    'settings.notifications.toggle.emailNotifications.desc': 'Recibir actualizaciones por correo',
    'settings.notifications.toggle.depositAlerts.label': 'Alertas de depósito',
    'settings.notifications.toggle.depositAlerts.desc': 'Aviso cuando se confirman depósitos',
    'settings.notifications.toggle.withdrawalAlerts.label': 'Alertas de retiro',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'Aviso ante cambios de estado del retiro',
    'settings.notifications.toggle.investmentUpdates.label': 'Actualizaciones de inversión',
    'settings.notifications.toggle.investmentUpdates.desc':
      'Intereses mensuales y avisos del plan',
    'settings.notifications.toggle.referralAlerts.label': 'Alertas de referidos',
    'settings.notifications.toggle.referralAlerts.desc':
      'Avisos por actividad de referidos',
    'user.settings.preferences.summary':
      '{{enabled}} de {{total}} tipos de alerta por correo están activos. Abre el cuadro para cambiar depósitos, retiros y más.',
    'user.settings.preferences.manage': 'Gestionar preferencias de notificación',
    'user.settings.preferences.modalTitle': 'Preferencias de notificación',
    'user.settings.preferences.modalHint':
      'Elige qué correos enviamos. Puedes cambiarlo cuando quieras.',
    'user.settings.preferences.toastNotificationsSaved': 'Preferencias de notificación guardadas',
    'user.settings.preferences.saveNotifications': 'Guardar notificaciones',
    'settings.preferences.toastSaved': 'Preferencias guardadas',
    'settings.security.recoveryTitle': 'Frase de recuperación',
    'settings.security.recoveryBefore':
      'Tu frase de 12 palabras se mostró una sola vez al crear la cuenta. No la guardamos en texto plano y no puede mostrarse aquí. Para restablecer la contraseña, usa',
    'settings.security.recoveryAfter': 'con tu frase guardada.',
    'settings.security.forgotPasswordLink': 'Olvidé mi contraseña',
    'settings.password.title': 'Cambiar contraseña',
    'settings.password.current': 'Contraseña actual',
    'settings.password.new': 'Nueva contraseña',
    'settings.password.confirm': 'Confirmar contraseña',
    'settings.password.show': 'Mostrar',
    'settings.password.hide': 'Ocultar',
    'settings.password.match': 'Las contraseñas coinciden',
    'settings.password.noMatch': 'Las contraseñas no coinciden',
    'settings.password.errMinLen': 'Se requieren al menos 8 caracteres',
    'settings.password.errSameAsCurrent': 'La nueva contraseña debe ser distinta de la actual',
    'settings.password.errMismatch': 'Las contraseñas no coinciden',
    'settings.password.toastUpdateFailed': 'No se pudo actualizar la contraseña',
    'settings.password.toastUpdated': 'Contraseña actualizada correctamente',
    'settings.password.submit': 'Actualizar contraseña',
    'settings.password.updating': 'Actualizando…',
    'settings.profile.cropPhotoAria': 'Elegir foto para recortar',
    'settings.profile.addNameHint': 'Añade tu nombre completo en el formulario.',
    'settings.profile.activeAccount': 'Cuenta activa',
    'settings.profile.choosePhoto': 'Elegir foto',
    'settings.profile.working': 'Trabajando…',
    'settings.profile.removePhoto': 'Quitar foto',
    'settings.profile.infoTitle': 'Información del perfil',
    'settings.profile.fullName': 'Nombre completo',
    'settings.profile.placeholderFullName': 'Tu nombre completo',
    'settings.profile.email': 'Correo electrónico',
    'settings.profile.emailLockedHint': 'El correo no se puede cambiar',
    'settings.profile.phone': 'Teléfono',
    'settings.profile.phonePlaceholder': '+34… o solo dígitos',
    'settings.profile.address': 'Dirección',
    'settings.profile.username': 'Usuario',
    'settings.profile.saveChanges': 'Guardar cambios',
    'settings.profile.nameRequired': 'El nombre completo es obligatorio',
    'settings.profile.updatedToast': 'Perfil actualizado correctamente',
    'settings.profile.uploadFailed': 'Error al subir',
    'settings.profile.removeFailed': 'No se pudo quitar la foto',
    'settings.profile.photoUpdated': 'Foto actualizada',
    'settings.profile.photoRemoved': 'Foto eliminada',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'Recortar foto de perfil',
    'settings.avatarCrop.hint':
      'Arrastra para mover, usa el control para ampliar. La foto se guarda cuadrada.',
    'settings.avatarCrop.zoom': 'Zoom',
    'settings.avatarCrop.zoomAria': 'Zoom del recorte',
    'settings.avatarCrop.savePhoto': 'Guardar foto',
    'settings.avatarCrop.uploading': 'Subiendo…',
    'settings.avatarCrop.toastWaitLoad': 'Espera a que cargue la imagen e inténtalo de nuevo.',
    'settings.avatarCrop.toastCropFail':
      'No se pudo recortar esta imagen. Prueba JPEG o PNG.',
    'settings.currency': 'Moneda',
    'settings.selectCurrency': 'Seleccionar moneda',
    'settings.languagePlaceholder': 'Seleccionar idioma',
    'common.cancel': 'Cancelar',
    'common.next': 'Siguiente',
    'common.previous': 'Anterior',
    'user.page.transactions': 'Transacciones',
    'user.transactions.sectionTitle': 'Historial de transacciones',
    'user.transactions.loading': 'Cargando transacciones…',
    'user.transactions.emptyTitle': 'No hay transacciones',
    'user.transactions.emptyHint': 'Prueba a ajustar los filtros',
    'user.transactions.col.date': 'Fecha y hora',
    'user.transactions.col.type': 'Tipo',
    'user.transactions.col.description': 'Descripción',
    'user.transactions.col.amount': 'Importe',
    'user.transactions.col.status': 'Estado',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'Mostrando {{from}}–{{to}} de {{total}} transacciones',
    'user.transactions.filter.from': 'Desde',
    'user.transactions.filter.to': 'Hasta',
    'user.transactions.filter.searchPlaceholder': 'Buscar TXID o descripción…',
    'user.transactions.filter.all': 'Todas',
    'user.transactions.filter.deposit': 'Depósito',
    'user.transactions.filter.withdrawal': 'Retiro',
    'user.transactions.filter.investment': 'Inversión',
    'user.transactions.filter.evoucher': 'E-Voucher',
    'user.transactions.filter.referral': 'Referido',
    'user.transactions.filter.stopLoss': 'Stop-Loss',
    'user.transactions.badge.deposit': 'Depósito',
    'user.transactions.badge.withdrawal': 'Retiro',
    'user.transactions.badge.investment': 'Inversión',
    'user.transactions.badge.e-voucher': 'E-Voucher',
    'user.transactions.badge.referral': 'Referido',
    'user.transactions.badge.bonus': 'Bono',
    'user.transactions.badge.stop-loss': 'Stop-Loss',
    'user.transactions.badge.completed': 'Completado',
    'user.transactions.badge.active': 'Activo',
    'user.transactions.badge.pending': 'Pendiente',
    'user.transactions.badge.confirming': 'Confirmando',
    'user.transactions.badge.approved': 'Aprobado',
    'user.transactions.badge.cancelled': 'Cancelado',
    'user.transactions.badge.rejected': 'Rechazado',
    'user.transactions.badge.failed': 'Fallido',
    'user.transactions.exportCsv': 'Exportar CSV',
    'user.transactions.exportCsvTitle': 'Exportar como CSV',
    'user.transactions.exportNoData': 'No hay datos para exportar',
  },

  ar: {
    'user.settings.intro': 'حدّث ملفك الشخصي والأمان وتفضيلات هذا الحساب.',
    'agent.settings.intro': 'حدّث ملفك الشخصي والأمان وتفضيلات العرض لحساب الوكيل.',
    'settings.tab.profile': 'الملف الشخصي',
    'settings.tab.security': 'الأمان',
    'settings.tab.preferences': 'التفضيلات',
    'settings.shell.loading': 'جاري تحميل الإعدادات…',
    'settings.shell.errorTitle': 'تعذر تحميل الإعدادات',
    'settings.shell.errorHint':
      'تحقق من الاتصال، أو سجّل الخروج ثم الدخول إذا انتهت الجلسة.',
    'settings.shell.tryAgain': 'إعادة المحاولة',
    'settings.shell.sessionExpired': 'انتهت الجلسة — سجّل الدخول مرة أخرى',
    'settings.shell.loadProfileFailed': 'تعذر تحميل الملف الشخصي',
    'settings.shell.invalidProfile': 'استجابة ملف شخصي غير صالحة',
    'settings.shell.saveFailed': 'فشل الحفظ',
    'settings.notifications.sectionTitle': 'الإشعارات',
    'settings.notifications.toggle.emailNotifications.label': 'إشعارات البريد',
    'settings.notifications.toggle.emailNotifications.desc': 'استلام التحديثات عبر البريد',
    'settings.notifications.toggle.depositAlerts.label': 'تنبيهات الإيداع',
    'settings.notifications.toggle.depositAlerts.desc': 'إشعار عند تأكيد الإيداعات',
    'settings.notifications.toggle.withdrawalAlerts.label': 'تنبيهات السحب',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'إشعار عند تغيّر حالة السحب',
    'settings.notifications.toggle.investmentUpdates.label': 'تحديثات الاستثمار',
    'settings.notifications.toggle.investmentUpdates.desc': 'الفائدة الشهرية وإشعارات الخطة',
    'settings.notifications.toggle.referralAlerts.label': 'تنبيهات الإحالة',
    'settings.notifications.toggle.referralAlerts.desc': 'إشعارات نشاط الإحالة',
    'user.settings.preferences.summary':
      '{{enabled}} من أصل {{total}} أنواع تنبيهات البريد مفعّلة. افتح الحوار لتغيير الإيداع والسحب وغيرها.',
    'user.settings.preferences.manage': 'إدارة تفضيلات الإشعارات',
    'user.settings.preferences.modalTitle': 'تفضيلات الإشعارات',
    'user.settings.preferences.modalHint':
      'اختر رسائل البريد التي نرسلها. يمكنك التحديث في أي وقت.',
    'user.settings.preferences.toastNotificationsSaved': 'تم حفظ تفضيلات الإشعارات',
    'user.settings.preferences.saveNotifications': 'حفظ الإشعارات',
    'settings.preferences.toastSaved': 'تم حفظ التفضيلات',
    'settings.security.recoveryTitle': 'عبارة الاسترداد',
    'settings.security.recoveryBefore':
      'ظهرت عبارتك المكونة من 12 كلمة مرة واحدة عند إنشاء الحساب. لا نخزنها كنص عادي ولا يمكن عرضها هنا. لإعادة تعيين كلمة المرور استخدم',
    'settings.security.recoveryAfter': 'مع العبارة المحفوظة.',
    'settings.security.forgotPasswordLink': 'نسيت كلمة المرور',
    'settings.password.title': 'تغيير كلمة المرور',
    'settings.password.current': 'كلمة المرور الحالية',
    'settings.password.new': 'كلمة مرور جديدة',
    'settings.password.confirm': 'تأكيد كلمة المرور',
    'settings.password.show': 'إظهار',
    'settings.password.hide': 'إخفاء',
    'settings.password.match': 'كلمتا المرور متطابقتان',
    'settings.password.noMatch': 'كلمتا المرور غير متطابقتين',
    'settings.password.errMinLen': 'يلزم 8 أحرف على الأقل',
    'settings.password.errSameAsCurrent': 'يجب أن تختلف كلمة المرور الجديدة عن الحالية',
    'settings.password.errMismatch': 'كلمتا المرور غير متطابقتين',
    'settings.password.toastUpdateFailed': 'تعذر تحديث كلمة المرور',
    'settings.password.toastUpdated': 'تم تحديث كلمة المرور بنجاح',
    'settings.password.submit': 'تحديث كلمة المرور',
    'settings.password.updating': 'جاري التحديث…',
    'settings.profile.cropPhotoAria': 'اختر صورة للقص',
    'settings.profile.addNameHint': 'أضف اسمك الكامل في النموذج أدناه.',
    'settings.profile.activeAccount': 'حساب نشط',
    'settings.profile.choosePhoto': 'اختيار صورة',
    'settings.profile.working': 'جاري العمل…',
    'settings.profile.removePhoto': 'إزالة الصورة',
    'settings.profile.infoTitle': 'معلومات الملف الشخصي',
    'settings.profile.fullName': 'الاسم الكامل',
    'settings.profile.placeholderFullName': 'اسمك الكامل',
    'settings.profile.email': 'البريد الإلكتروني',
    'settings.profile.emailLockedHint': 'لا يمكن تغيير البريد',
    'settings.profile.phone': 'رقم الهاتف',
    'settings.profile.phonePlaceholder': '+966… أو أرقام فقط',
    'settings.profile.address': 'العنوان',
    'settings.profile.username': 'اسم المستخدم',
    'settings.profile.saveChanges': 'حفظ التغييرات',
    'settings.profile.nameRequired': 'الاسم الكامل مطلوب',
    'settings.profile.updatedToast': 'تم تحديث الملف الشخصي',
    'settings.profile.uploadFailed': 'فشل الرفع',
    'settings.profile.removeFailed': 'تعذر إزالة الصورة',
    'settings.profile.photoUpdated': 'تم تحديث الصورة',
    'settings.profile.photoRemoved': 'تمت إزالة الصورة',
    'settings.profile.avatarFallbackLetter': '؟',
    'user.profile.cropPhotoTitle': 'قص صورة الملف الشخصي',
    'settings.avatarCrop.hint':
      'اسحب لإعادة الموضع، واستخدم شريط التكبير. تُحفظ الصورة مربعة.',
    'settings.avatarCrop.zoom': 'تكبير',
    'settings.avatarCrop.zoomAria': 'تكبير القص',
    'settings.avatarCrop.savePhoto': 'حفظ الصورة',
    'settings.avatarCrop.uploading': 'جاري الرفع…',
    'settings.avatarCrop.toastWaitLoad': 'انتظر تحميل الصورة ثم أعد المحاولة.',
    'settings.avatarCrop.toastCropFail': 'تعذر قص هذه الصورة. جرّب JPEG أو PNG.',
    'settings.currency': 'العملة',
    'settings.selectCurrency': 'اختر العملة',
    'settings.languagePlaceholder': 'اختر اللغة',
    'common.cancel': 'إلغاء',
    'common.next': 'التالي',
    'common.previous': 'السابق',
    'user.page.transactions': 'المعاملات',
    'user.transactions.sectionTitle': 'سجل المعاملات',
    'user.transactions.loading': 'جاري تحميل المعاملات…',
    'user.transactions.emptyTitle': 'لا توجد معاملات',
    'user.transactions.emptyHint': 'جرّب تعديل المرشحات',
    'user.transactions.col.date': 'التاريخ والوقت',
    'user.transactions.col.type': 'النوع',
    'user.transactions.col.description': 'الوصف',
    'user.transactions.col.amount': 'المبلغ',
    'user.transactions.col.status': 'الحالة',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'عرض {{from}}–{{to}} من {{total}} معاملة',
    'user.transactions.filter.from': 'من',
    'user.transactions.filter.to': 'إلى',
    'user.transactions.filter.searchPlaceholder': 'بحث في TXID أو الوصف…',
    'user.transactions.filter.all': 'الكل',
    'user.transactions.filter.deposit': 'إيداع',
    'user.transactions.filter.withdrawal': 'سحب',
    'user.transactions.filter.investment': 'استثمار',
    'user.transactions.filter.evoucher': 'قسيمة إلكترونية',
    'user.transactions.filter.referral': 'إحالة',
    'user.transactions.filter.stopLoss': 'وقف الخسارة',
    'user.transactions.badge.deposit': 'إيداع',
    'user.transactions.badge.withdrawal': 'سحب',
    'user.transactions.badge.investment': 'استثمار',
    'user.transactions.badge.e-voucher': 'قسيمة إلكترونية',
    'user.transactions.badge.referral': 'إحالة',
    'user.transactions.badge.bonus': 'مكافأة',
    'user.transactions.badge.stop-loss': 'وقف الخسارة',
    'user.transactions.badge.completed': 'مكتمل',
    'user.transactions.badge.active': 'نشط',
    'user.transactions.badge.pending': 'قيد الانتظار',
    'user.transactions.badge.confirming': 'جاري التأكيد',
    'user.transactions.badge.approved': 'موافق عليه',
    'user.transactions.badge.cancelled': 'ملغى',
    'user.transactions.badge.rejected': 'مرفوض',
    'user.transactions.badge.failed': 'فشل',
    'user.transactions.exportCsv': 'تصدير CSV',
    'user.transactions.exportCsvTitle': 'تصدير كملف CSV',
    'user.transactions.exportNoData': 'لا توجد بيانات للتصدير',
  },

  bn: {
    'user.settings.intro': 'এই অ্যাকাউন্টের প্রোফাইল, নিরাপত্তা ও পছন্দ আপডেট করুন।',
    'agent.settings.intro':
      'এই এজেন্ট অ্যাকাউন্টের প্রোফাইল, নিরাপত্তা ও প্রদর্শন পছন্দ আপডেট করুন।',
    'settings.tab.profile': 'প্রোফাইল',
    'settings.tab.security': 'নিরাপত্তা',
    'settings.tab.preferences': 'পছন্দসমূহ',
    'settings.shell.loading': 'সেটিংস লোড হচ্ছে…',
    'settings.shell.errorTitle': 'সেটিংস লোড করা যায়নি',
    'settings.shell.errorHint':
      'সংযোগ পরীক্ষা করুন, অথবা সেশন শেষ হলে সাইন আউট করে আবার সাইন ইন করুন।',
    'settings.shell.tryAgain': 'আবার চেষ্টা',
    'settings.shell.sessionExpired': 'সেশন শেষ — আবার সাইন ইন করুন',
    'settings.shell.loadProfileFailed': 'প্রোফাইল লোড করা যায়নি',
    'settings.shell.invalidProfile': 'অবৈধ প্রোফাইল প্রতিক্রিয়া',
    'settings.shell.saveFailed': 'সংরক্ষণ ব্যর্থ',
    'settings.notifications.sectionTitle': 'বিজ্ঞপ্তি',
    'settings.notifications.toggle.emailNotifications.label': 'ইমেইল বিজ্ঞপ্তি',
    'settings.notifications.toggle.emailNotifications.desc': 'ইমেইলে আপডেট পান',
    'settings.notifications.toggle.depositAlerts.label': 'জমা সতর্কতা',
    'settings.notifications.toggle.depositAlerts.desc': 'জমা নিশ্চিত হলে জানান',
    'settings.notifications.toggle.withdrawalAlerts.label': 'উত্তোলন সতর্কতা',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'উত্তোলনের অবস্থা বদলালে জানান',
    'settings.notifications.toggle.investmentUpdates.label': 'বিনিয়োগ আপডেট',
    'settings.notifications.toggle.investmentUpdates.desc': 'মাসিক সুদ ও প্ল্যান বিজ্ঞপ্তি',
    'settings.notifications.toggle.referralAlerts.label': 'রেফারাল সতর্কতা',
    'settings.notifications.toggle.referralAlerts.desc': 'রেফারাল কার্যকলাপের বিজ্ঞপ্তি',
    'user.settings.preferences.summary':
      '{{total}}-এর মধ্যে {{enabled}}টি ইমেইল সতর্কতা চালু। জমা, উত্তোলন ইত্যাদি পরিবর্তনে ডায়ালগ খুলুন।',
    'user.settings.preferences.manage': 'বিজ্ঞপ্তি পছন্দ পরিচালনা',
    'user.settings.preferences.modalTitle': 'বিজ্ঞপ্তি পছন্দ',
    'user.settings.preferences.modalHint':
      'কোন অ্যাকাউন্ট ইমেইল পাঠাব তা বেছে নিন। যেকোনো সময় আপডেট করতে পারবেন।',
    'user.settings.preferences.toastNotificationsSaved': 'বিজ্ঞপ্তি পছন্দ সংরক্ষিত',
    'user.settings.preferences.saveNotifications': 'বিজ্ঞপ্তি সংরক্ষণ',
    'settings.preferences.toastSaved': 'পছন্দ সংরক্ষিত',
    'settings.security.recoveryTitle': 'পুনরুদ্ধার বাক্য',
    'settings.security.recoveryBefore':
      'আপনার ১২-শব্দের বাক্য একবারই দেখানো হয়েছিল। আমরা এটি সাদা টেক্সটে রাখি না, তাই এখানে দেখানো যাবে না। ভুলে যাওয়া পাসওয়ার্ড রিসেট করতে ব্যবহার করুন',
    'settings.security.recoveryAfter': 'আপনার সংরক্ষিত বাক্য দিয়ে।',
    'settings.security.forgotPasswordLink': 'পাসওয়ার্ড ভুলে গেছেন',
    'settings.password.title': 'পাসওয়ার্ড পরিবর্তন',
    'settings.password.current': 'বর্তমান পাসওয়ার্ড',
    'settings.password.new': 'নতুন পাসওয়ার্ড',
    'settings.password.confirm': 'পাসওয়ার্ড নিশ্চিত করুন',
    'settings.password.show': 'দেখান',
    'settings.password.hide': 'লুকান',
    'settings.password.match': 'পাসওয়ার্ড মিলেছে',
    'settings.password.noMatch': 'পাসওয়ার্ড মিলছে না',
    'settings.password.errMinLen': 'কমপক্ষে ৮ অক্ষর লাগবে',
    'settings.password.errSameAsCurrent': 'নতুন পাসওয়ার্ড বর্তমানের থেকে আলাদা হতে হবে',
    'settings.password.errMismatch': 'পাসওয়ার্ড মিলছে না',
    'settings.password.toastUpdateFailed': 'পাসওয়ার্ড আপডেট করা যায়নি',
    'settings.password.toastUpdated': 'পাসওয়ার্ড সফলভাবে আপডেট হয়েছে',
    'settings.password.submit': 'পাসওয়ার্ড আপডেট',
    'settings.password.updating': 'আপডেট হচ্ছে…',
    'settings.profile.cropPhotoAria': 'ক্রপ করতে ছবি বেছে নিন',
    'settings.profile.addNameHint': 'নিচের ফর্মে পূর্ণ নাম যোগ করুন।',
    'settings.profile.activeAccount': 'সক্রিয় অ্যাকাউন্ট',
    'settings.profile.choosePhoto': 'ছবি বেছে নিন',
    'settings.profile.working': 'কাজ চলছে…',
    'settings.profile.removePhoto': 'ছবি সরান',
    'settings.profile.infoTitle': 'প্রোফাইল তথ্য',
    'settings.profile.fullName': 'পূর্ণ নাম',
    'settings.profile.placeholderFullName': 'আপনার পূর্ণ নাম',
    'settings.profile.email': 'ইমেইল',
    'settings.profile.emailLockedHint': 'ইমেইল পরিবর্তন করা যাবে না',
    'settings.profile.phone': 'ফোন নম্বর',
    'settings.profile.phonePlaceholder': '+৮৮০… অথবা শুধু সংখ্যা',
    'settings.profile.address': 'ঠিকানা',
    'settings.profile.username': 'ব্যবহারকারীর নাম',
    'settings.profile.saveChanges': 'পরিবর্তন সংরক্ষণ',
    'settings.profile.nameRequired': 'পূর্ণ নাম প্রয়োজন',
    'settings.profile.updatedToast': 'প্রোফাইল সফলভাবে আপডেট হয়েছে',
    'settings.profile.uploadFailed': 'আপলোড ব্যর্থ',
    'settings.profile.removeFailed': 'ছবি সরানো যায়নি',
    'settings.profile.photoUpdated': 'ছবি আপডেট হয়েছে',
    'settings.profile.photoRemoved': 'ছবি সরানো হয়েছে',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'প্রোফাইল ছবি ক্রপ',
    'settings.avatarCrop.hint':
      'সরাতে টেনে আনুন, জুম স্লাইডার ব্যবহার করুন। ছবি বর্গাকারে সংরক্ষিত হয়।',
    'settings.avatarCrop.zoom': 'জুম',
    'settings.avatarCrop.zoomAria': 'ক্রপ জুম',
    'settings.avatarCrop.savePhoto': 'ছবি সংরক্ষণ',
    'settings.avatarCrop.uploading': 'আপলোড হচ্ছে…',
    'settings.avatarCrop.toastWaitLoad': 'ছবি লোড হতে দিন, তারপর আবার চেষ্টা করুন।',
    'settings.avatarCrop.toastCropFail': 'এই ছবি ক্রপ করা যায়নি। JPEG বা PNG চেষ্টা করুন।',
    'settings.currency': 'মুদ্রা',
    'settings.selectCurrency': 'মুদ্রা নির্বাচন',
    'settings.languagePlaceholder': 'ভাষা নির্বাচন',
    'common.cancel': 'বাতিল',
    'common.next': 'পরবর্তী',
    'common.previous': 'পূর্ববর্তী',
    'user.page.transactions': 'লেনদেন',
    'user.transactions.sectionTitle': 'লেনদেনের ইতিহাস',
    'user.transactions.loading': 'লেনদেন লোড হচ্ছে…',
    'user.transactions.emptyTitle': 'কোনো লেনদেন নেই',
    'user.transactions.emptyHint': 'ফিল্টার সামঞ্জস্য করুন',
    'user.transactions.col.date': 'তারিখ ও সময়',
    'user.transactions.col.type': 'ধরন',
    'user.transactions.col.description': 'বিবরণ',
    'user.transactions.col.amount': 'পরিমাণ',
    'user.transactions.col.status': 'স্ট্যাটাস',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '{{total}}-এর মধ্যে {{from}}–{{to}} লেনদেন দেখাচ্ছে',
    'user.transactions.filter.from': 'থেকে',
    'user.transactions.filter.to': 'পর্যন্ত',
    'user.transactions.filter.searchPlaceholder': 'TXID বা বিবরণ খুঁজুন…',
    'user.transactions.filter.all': 'সব',
    'user.transactions.filter.deposit': 'জমা',
    'user.transactions.filter.withdrawal': 'উত্তোলন',
    'user.transactions.filter.investment': 'বিনিয়োগ',
    'user.transactions.filter.evoucher': 'ই-ভাউচার',
    'user.transactions.filter.referral': 'রেফারাল',
    'user.transactions.filter.stopLoss': 'স্টপ-লস',
    'user.transactions.badge.deposit': 'জমা',
    'user.transactions.badge.withdrawal': 'উত্তোলন',
    'user.transactions.badge.investment': 'বিনিয়োগ',
    'user.transactions.badge.e-voucher': 'ই-ভাউচার',
    'user.transactions.badge.referral': 'রেফারাল',
    'user.transactions.badge.bonus': 'বোনাস',
    'user.transactions.badge.stop-loss': 'স্টপ-লস',
    'user.transactions.badge.completed': 'সম্পন্ন',
    'user.transactions.badge.active': 'সক্রিয়',
    'user.transactions.badge.pending': 'বিচারাধীন',
    'user.transactions.badge.confirming': 'নিশ্চিত হচ্ছে',
    'user.transactions.badge.approved': 'অনুমোদিত',
    'user.transactions.badge.cancelled': 'বাতিল',
    'user.transactions.badge.rejected': 'প্রত্যাখ্যাত',
    'user.transactions.badge.failed': 'ব্যর্থ',
    'user.transactions.exportCsv': 'CSV রপ্তানি',
    'user.transactions.exportCsvTitle': 'CSV হিসেবে রপ্তানি',
    'user.transactions.exportNoData': 'রপ্তানির জন্য কোনো ডেটা নেই',
  },

  hi: {
    'user.settings.intro': 'इस खाते के लिए प्रोफ़ाइल, सुरक्षा और प्राथमिकताएँ अपडेट करें।',
    'agent.settings.intro':
      'इस एजेंट खाते के लिए प्रोफ़ाइल, सुरक्षा और प्रदर्शन प्राथमिकताएँ अपडेट करें।',
    'settings.tab.profile': 'प्रोफ़ाइल',
    'settings.tab.security': 'सुरक्षा',
    'settings.tab.preferences': 'प्राथमिकताएँ',
    'settings.shell.loading': 'सेटिंग्स लोड हो रही हैं…',
    'settings.shell.errorTitle': 'सेटिंग्स लोड नहीं हो सकीं',
    'settings.shell.errorHint':
      'कनेक्शन जाँचें, या सत्र समाप्त होने पर साइन आउट करके फिर साइन इन करें।',
    'settings.shell.tryAgain': 'फिर कोशिश करें',
    'settings.shell.sessionExpired': 'सत्र समाप्त — कृपया फिर साइन इन करें',
    'settings.shell.loadProfileFailed': 'प्रोफ़ाइल लोड नहीं हो सकी',
    'settings.shell.invalidProfile': 'अमान्य प्रोफ़ाइल प्रतिक्रिया',
    'settings.shell.saveFailed': 'सहेजना विफल',
    'settings.notifications.sectionTitle': 'सूचनाएँ',
    'settings.notifications.toggle.emailNotifications.label': 'ईमेल सूचनाएँ',
    'settings.notifications.toggle.emailNotifications.desc': 'ईमेल पर अपडेट प्राप्त करें',
    'settings.notifications.toggle.depositAlerts.label': 'जमा अलर्ट',
    'settings.notifications.toggle.depositAlerts.desc': 'जमा पुष्ट होने पर सूचित करें',
    'settings.notifications.toggle.withdrawalAlerts.label': 'निकासी अलर्ट',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'निकासी स्थिति बदलने पर सूचित करें',
    'settings.notifications.toggle.investmentUpdates.label': 'निवेश अपडेट',
    'settings.notifications.toggle.investmentUpdates.desc': 'मासिक ब्याज और योजना सूचनाएँ',
    'settings.notifications.toggle.referralAlerts.label': 'रेफ़रल अलर्ट',
    'settings.notifications.toggle.referralAlerts.desc': 'रेफ़रल गतिविधि की सूचनाएँ',
    'user.settings.preferences.summary':
      '{{total}} में से {{enabled}} ईमेल अलर्ट प्रकार चालू हैं। जमा, निकासी आदि बदलने के लिए संवाद खोलें।',
    'user.settings.preferences.manage': 'सूचना प्राथमिकताएँ प्रबंधित करें',
    'user.settings.preferences.modalTitle': 'सूचना प्राथमिकताएँ',
    'user.settings.preferences.modalHint':
      'चुनें कि हम कौन से खाता ईमेल भेजें। कभी भी अपडेट कर सकते हैं।',
    'user.settings.preferences.toastNotificationsSaved': 'सूचना प्राथमिकताएँ सहेजी गईं',
    'user.settings.preferences.saveNotifications': 'सूचनाएँ सहेजें',
    'settings.preferences.toastSaved': 'प्राथमिकताएँ सहेजी गईं',
    'settings.security.recoveryTitle': 'रिकवरी वाक्यांश',
    'settings.security.recoveryBefore':
      'आपका 12-शब्द वाक्यांश खाता बनाते समय एक बार दिखाया गया था। हम इसे सादे पाठ में संग्रहीत नहीं करते, इसलिए यहाँ नहीं दिखाया जा सकता। भूले पासवर्ड रीसेट के लिए उपयोग करें',
    'settings.security.recoveryAfter': 'अपने सहेजे वाक्यांश के साथ।',
    'settings.security.forgotPasswordLink': 'पासवर्ड भूल गए',
    'settings.password.title': 'पासवर्ड बदलें',
    'settings.password.current': 'वर्तमान पासवर्ड',
    'settings.password.new': 'नया पासवर्ड',
    'settings.password.confirm': 'पासवर्ड की पुष्टि करें',
    'settings.password.show': 'दिखाएँ',
    'settings.password.hide': 'छिपाएँ',
    'settings.password.match': 'पासवर्ड मेल खाते हैं',
    'settings.password.noMatch': 'पासवर्ड मेल नहीं खाते',
    'settings.password.errMinLen': 'कम से कम 8 वर्ण आवश्यक',
    'settings.password.errSameAsCurrent': 'नया पासवर्ड वर्तमान से अलग होना चाहिए',
    'settings.password.errMismatch': 'पासवर्ड मेल नहीं खाते',
    'settings.password.toastUpdateFailed': 'पासवर्ड अपडेट नहीं हो सका',
    'settings.password.toastUpdated': 'पासवर्ड सफलतापूर्वक अपडेट हुआ',
    'settings.password.submit': 'पासवर्ड अपडेट करें',
    'settings.password.updating': 'अपडेट हो रहा है…',
    'settings.profile.cropPhotoAria': 'क्रॉप के लिए फ़ोटो चुनें',
    'settings.profile.addNameHint': 'नीचे फ़ॉर्म में अपना पूरा नाम जोड़ें।',
    'settings.profile.activeAccount': 'सक्रिय खाता',
    'settings.profile.choosePhoto': 'फ़ोटो चुनें',
    'settings.profile.working': 'काम हो रहा है…',
    'settings.profile.removePhoto': 'फ़ोटो हटाएँ',
    'settings.profile.infoTitle': 'प्रोफ़ाइल जानकारी',
    'settings.profile.fullName': 'पूरा नाम',
    'settings.profile.placeholderFullName': 'आपका पूरा नाम',
    'settings.profile.email': 'ईमेल',
    'settings.profile.emailLockedHint': 'ईमेल बदला नहीं जा सकता',
    'settings.profile.phone': 'फ़ोन नंबर',
    'settings.profile.phonePlaceholder': '+91… या केवल अंक',
    'settings.profile.address': 'पता',
    'settings.profile.username': 'उपयोगकर्ता नाम',
    'settings.profile.saveChanges': 'परिवर्तन सहेजें',
    'settings.profile.nameRequired': 'पूरा नाम आवश्यक है',
    'settings.profile.updatedToast': 'प्रोफ़ाइल सफलतापूर्वक अपडेट हुई',
    'settings.profile.uploadFailed': 'अपलोड विफल',
    'settings.profile.removeFailed': 'फ़ोटो नहीं हटा सके',
    'settings.profile.photoUpdated': 'फ़ोटो अपडेट हुई',
    'settings.profile.photoRemoved': 'फ़ोटो हटाई गई',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'प्रोफ़ाइल फ़ोटो क्रॉप करें',
    'settings.avatarCrop.hint':
      'स्थान बदलने के लिए खींचें, ज़ूम के लिए स्लाइडर। फ़ोटो वर्गाकार सहेजी जाती है।',
    'settings.avatarCrop.zoom': 'ज़ूम',
    'settings.avatarCrop.zoomAria': 'क्रॉप ज़ूम',
    'settings.avatarCrop.savePhoto': 'फ़ोटो सहेजें',
    'settings.avatarCrop.uploading': 'अपलोड हो रहा है…',
    'settings.avatarCrop.toastWaitLoad': 'छवि लोड होने दें, फिर पुनः प्रयास करें।',
    'settings.avatarCrop.toastCropFail': 'यह छवि क्रॉप नहीं हो सकी। JPEG या PNG आज़माएँ।',
    'settings.currency': 'मुद्रा',
    'settings.selectCurrency': 'मुद्रा चुनें',
    'settings.languagePlaceholder': 'भाषा चुनें',
    'common.cancel': 'रद्द करें',
    'common.next': 'अगला',
    'common.previous': 'पिछला',
    'user.page.transactions': 'लेनदेन',
    'user.transactions.sectionTitle': 'लेनदेन इतिहास',
    'user.transactions.loading': 'लेनदेन लोड हो रहे हैं…',
    'user.transactions.emptyTitle': 'कोई लेनदेन नहीं',
    'user.transactions.emptyHint': 'फ़िल्टर समायोजित करें',
    'user.transactions.col.date': 'दिनांक और समय',
    'user.transactions.col.type': 'प्रकार',
    'user.transactions.col.description': 'विवरण',
    'user.transactions.col.amount': 'राशि',
    'user.transactions.col.status': 'स्थिति',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '{{total}} में से {{from}}–{{to}} लेनदेन दिखा रहे हैं',
    'user.transactions.filter.from': 'से',
    'user.transactions.filter.to': 'तक',
    'user.transactions.filter.searchPlaceholder': 'TXID या विवरण खोजें…',
    'user.transactions.filter.all': 'सभी',
    'user.transactions.filter.deposit': 'जमा',
    'user.transactions.filter.withdrawal': 'निकासी',
    'user.transactions.filter.investment': 'निवेश',
    'user.transactions.filter.evoucher': 'ई-वाउचर',
    'user.transactions.filter.referral': 'रेफ़रल',
    'user.transactions.filter.stopLoss': 'स्टॉप-लॉस',
    'user.transactions.badge.deposit': 'जमा',
    'user.transactions.badge.withdrawal': 'निकासी',
    'user.transactions.badge.investment': 'निवेश',
    'user.transactions.badge.e-voucher': 'ई-वाउचर',
    'user.transactions.badge.referral': 'रेफ़रल',
    'user.transactions.badge.bonus': 'बोनस',
    'user.transactions.badge.stop-loss': 'स्टॉप-लॉस',
    'user.transactions.badge.completed': 'पूर्ण',
    'user.transactions.badge.active': 'सक्रिय',
    'user.transactions.badge.pending': 'लंबित',
    'user.transactions.badge.confirming': 'पुष्टि हो रही है',
    'user.transactions.badge.approved': 'स्वीकृत',
    'user.transactions.badge.cancelled': 'रद्द',
    'user.transactions.badge.rejected': 'अस्वीकृत',
    'user.transactions.badge.failed': 'विफल',
    'user.transactions.exportCsv': 'CSV निर्यात',
    'user.transactions.exportCsvTitle': 'CSV के रूप में निर्यात',
    'user.transactions.exportNoData': 'निर्यात के लिए कोई डेटा नहीं',
  },

  ja: {
    'user.settings.intro': 'このアカウントのプロフィール、セキュリティ、設定を更新します。',
    'agent.settings.intro':
      'このエージェントアカウントのプロフィール、セキュリティ、表示設定を更新します。',
    'settings.tab.profile': 'プロフィール',
    'settings.tab.security': 'セキュリティ',
    'settings.tab.preferences': '設定',
    'settings.shell.loading': '設定を読み込み中…',
    'settings.shell.errorTitle': '設定を読み込めませんでした',
    'settings.shell.errorHint':
      '接続を確認するか、セッションが切れた場合はサインアウトして再度サインインしてください。',
    'settings.shell.tryAgain': '再試行',
    'settings.shell.sessionExpired': 'セッションの有効期限が切れました — 再度サインインしてください',
    'settings.shell.loadProfileFailed': 'プロフィールを読み込めませんでした',
    'settings.shell.invalidProfile': '無効なプロフィール応答',
    'settings.shell.saveFailed': '保存に失敗しました',
    'settings.notifications.sectionTitle': '通知',
    'settings.notifications.toggle.emailNotifications.label': 'メール通知',
    'settings.notifications.toggle.emailNotifications.desc': 'メールで更新を受け取る',
    'settings.notifications.toggle.depositAlerts.label': '入金アラート',
    'settings.notifications.toggle.depositAlerts.desc': '入金が確認されたら通知',
    'settings.notifications.toggle.withdrawalAlerts.label': '出金アラート',
    'settings.notifications.toggle.withdrawalAlerts.desc': '出金ステータス変更時に通知',
    'settings.notifications.toggle.investmentUpdates.label': '投資の更新',
    'settings.notifications.toggle.investmentUpdates.desc': '月次利息とプラン通知',
    'settings.notifications.toggle.referralAlerts.label': '紹介アラート',
    'settings.notifications.toggle.referralAlerts.desc': '紹介活動の通知',
    'user.settings.preferences.summary':
      '{{total}} 種類のメールアラートのうち {{enabled}} 件がオンです。ダイアログで入金・出金などを変更できます。',
    'user.settings.preferences.manage': '通知設定を管理',
    'user.settings.preferences.modalTitle': '通知の設定',
    'user.settings.preferences.modalHint':
      '送信するアカウントメールを選択します。いつでも変更できます。',
    'user.settings.preferences.toastNotificationsSaved': '通知設定を保存しました',
    'user.settings.preferences.saveNotifications': '通知を保存',
    'settings.preferences.toastSaved': '設定を保存しました',
    'settings.security.recoveryTitle': 'リカバリーフレーズ',
    'settings.security.recoveryBefore':
      '12単語のフレーズはアカウント作成時に一度だけ表示されました。平文では保存しないためここでは表示できません。パスワードを忘れた場合は',
    'settings.security.recoveryAfter': '保存したフレーズでリセットしてください。',
    'settings.security.forgotPasswordLink': 'パスワードをお忘れですか',
    'settings.password.title': 'パスワードを変更',
    'settings.password.current': '現在のパスワード',
    'settings.password.new': '新しいパスワード',
    'settings.password.confirm': 'パスワードを確認',
    'settings.password.show': '表示',
    'settings.password.hide': '非表示',
    'settings.password.match': 'パスワードが一致しています',
    'settings.password.noMatch': 'パスワードが一致しません',
    'settings.password.errMinLen': '8文字以上が必要です',
    'settings.password.errSameAsCurrent': '新しいパスワードは現在のものと異なる必要があります',
    'settings.password.errMismatch': 'パスワードが一致しません',
    'settings.password.toastUpdateFailed': 'パスワードを更新できませんでした',
    'settings.password.toastUpdated': 'パスワードを更新しました',
    'settings.password.submit': 'パスワードを更新',
    'settings.password.updating': '更新中…',
    'settings.profile.cropPhotoAria': 'トリミングする写真を選択',
    'settings.profile.addNameHint': '下のフォームに氏名を入力してください。',
    'settings.profile.activeAccount': '有効なアカウント',
    'settings.profile.choosePhoto': '写真を選択',
    'settings.profile.working': '処理中…',
    'settings.profile.removePhoto': '写真を削除',
    'settings.profile.infoTitle': 'プロフィール情報',
    'settings.profile.fullName': '氏名',
    'settings.profile.placeholderFullName': 'お名前',
    'settings.profile.email': 'メール',
    'settings.profile.emailLockedHint': 'メールは変更できません',
    'settings.profile.phone': '電話番号',
    'settings.profile.phonePlaceholder': '+81… または数字のみ',
    'settings.profile.address': '住所',
    'settings.profile.username': 'ユーザー名',
    'settings.profile.saveChanges': '変更を保存',
    'settings.profile.nameRequired': '氏名は必須です',
    'settings.profile.updatedToast': 'プロフィールを更新しました',
    'settings.profile.uploadFailed': 'アップロードに失敗しました',
    'settings.profile.removeFailed': '写真を削除できませんでした',
    'settings.profile.photoUpdated': '写真を更新しました',
    'settings.profile.photoRemoved': '写真を削除しました',
    'settings.profile.avatarFallbackLetter': '？',
    'user.profile.cropPhotoTitle': 'プロフィール写真をトリミング',
    'settings.avatarCrop.hint':
      'ドラッグで位置調整、スライダーでズーム。写真は正方形で保存されます。',
    'settings.avatarCrop.zoom': 'ズーム',
    'settings.avatarCrop.zoomAria': 'トリミングのズーム',
    'settings.avatarCrop.savePhoto': '写真を保存',
    'settings.avatarCrop.uploading': 'アップロード中…',
    'settings.avatarCrop.toastWaitLoad': '画像の読み込みを待ってから再試行してください。',
    'settings.avatarCrop.toastCropFail': 'この画像をトリミングできません。JPEGまたはPNGを試してください。',
    'settings.currency': '通貨',
    'settings.selectCurrency': '通貨を選択',
    'settings.languagePlaceholder': '言語を選択',
    'common.cancel': 'キャンセル',
    'common.next': '次へ',
    'common.previous': '前へ',
    'user.page.transactions': '取引',
    'user.transactions.sectionTitle': '取引履歴',
    'user.transactions.loading': '取引を読み込み中…',
    'user.transactions.emptyTitle': '取引がありません',
    'user.transactions.emptyHint': 'フィルターを調整してください',
    'user.transactions.col.date': '日時',
    'user.transactions.col.type': '種類',
    'user.transactions.col.description': '説明',
    'user.transactions.col.amount': '金額',
    'user.transactions.col.status': 'ステータス',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '{{total}} 件中 {{from}}–{{to}} 件を表示',
    'user.transactions.filter.from': '開始',
    'user.transactions.filter.to': '終了',
    'user.transactions.filter.searchPlaceholder': 'TXIDまたは説明を検索…',
    'user.transactions.filter.all': 'すべて',
    'user.transactions.filter.deposit': '入金',
    'user.transactions.filter.withdrawal': '出金',
    'user.transactions.filter.investment': '投資',
    'user.transactions.filter.evoucher': 'Eバウチャー',
    'user.transactions.filter.referral': '紹介',
    'user.transactions.filter.stopLoss': 'ストップロス',
    'user.transactions.badge.deposit': '入金',
    'user.transactions.badge.withdrawal': '出金',
    'user.transactions.badge.investment': '投資',
    'user.transactions.badge.e-voucher': 'Eバウチャー',
    'user.transactions.badge.referral': '紹介',
    'user.transactions.badge.bonus': 'ボーナス',
    'user.transactions.badge.stop-loss': 'ストップロス',
    'user.transactions.badge.completed': '完了',
    'user.transactions.badge.active': '有効',
    'user.transactions.badge.pending': '保留',
    'user.transactions.badge.confirming': '確認中',
    'user.transactions.badge.approved': '承認済み',
    'user.transactions.badge.cancelled': 'キャンセル',
    'user.transactions.badge.rejected': '却下',
    'user.transactions.badge.failed': '失敗',
    'user.transactions.exportCsv': 'CSVをエクスポート',
    'user.transactions.exportCsvTitle': 'CSVとしてエクスポート',
    'user.transactions.exportNoData': 'エクスポートするデータがありません',
  },

  ko: {
    'user.settings.intro': '이 계정의 프로필, 보안 및 기본 설정을 업데이트합니다.',
    'agent.settings.intro':
      '이 에이전트 계정의 프로필, 보안 및 표시 기본 설정을 업데이트합니다.',
    'settings.tab.profile': '프로필',
    'settings.tab.security': '보안',
    'settings.tab.preferences': '환경설정',
    'settings.shell.loading': '설정 불러오는 중…',
    'settings.shell.errorTitle': '설정을 불러올 수 없습니다',
    'settings.shell.errorHint':
      '연결을 확인하거나 세션이 만료되었으면 로그아웃 후 다시 로그인하세요.',
    'settings.shell.tryAgain': '다시 시도',
    'settings.shell.sessionExpired': '세션 만료 — 다시 로그인하세요',
    'settings.shell.loadProfileFailed': '프로필을 불러올 수 없습니다',
    'settings.shell.invalidProfile': '잘못된 프로필 응답',
    'settings.shell.saveFailed': '저장 실패',
    'settings.notifications.sectionTitle': '알림',
    'settings.notifications.toggle.emailNotifications.label': '이메일 알림',
    'settings.notifications.toggle.emailNotifications.desc': '이메일로 업데이트 받기',
    'settings.notifications.toggle.depositAlerts.label': '입금 알림',
    'settings.notifications.toggle.depositAlerts.desc': '입금 확인 시 알림',
    'settings.notifications.toggle.withdrawalAlerts.label': '출금 알림',
    'settings.notifications.toggle.withdrawalAlerts.desc': '출금 상태 변경 시 알림',
    'settings.notifications.toggle.investmentUpdates.label': '투자 업데이트',
    'settings.notifications.toggle.investmentUpdates.desc': '월 이자 및 플랜 알림',
    'settings.notifications.toggle.referralAlerts.label': '추천 알림',
    'settings.notifications.toggle.referralAlerts.desc': '추천 활동 알림',
    'user.settings.preferences.summary':
      '이메일 알림 유형 {{total}}개 중 {{enabled}}개가 켜져 있습니다. 대화 상자에서 입금·출금 등을 변경하세요.',
    'user.settings.preferences.manage': '알림 기본 설정 관리',
    'user.settings.preferences.modalTitle': '알림 기본 설정',
    'user.settings.preferences.modalHint':
      '보낼 계정 이메일을 선택합니다. 언제든지 변경할 수 있습니다.',
    'user.settings.preferences.toastNotificationsSaved': '알림 기본 설정이 저장되었습니다',
    'user.settings.preferences.saveNotifications': '알림 저장',
    'settings.preferences.toastSaved': '기본 설정이 저장되었습니다',
    'settings.security.recoveryTitle': '복구 문구',
    'settings.security.recoveryBefore':
      '12단어 문구는 계정을 만들 때 한 번만 표시되었습니다. 평문으로 저장하지 않아 여기에 표시할 수 없습니다. 비밀번호를 잊었다면',
    'settings.security.recoveryAfter': '저장한 문구로 재설정하세요.',
    'settings.security.forgotPasswordLink': '비밀번호 찾기',
    'settings.password.title': '비밀번호 변경',
    'settings.password.current': '현재 비밀번호',
    'settings.password.new': '새 비밀번호',
    'settings.password.confirm': '비밀번호 확인',
    'settings.password.show': '표시',
    'settings.password.hide': '숨기기',
    'settings.password.match': '비밀번호가 일치합니다',
    'settings.password.noMatch': '비밀번호가 일치하지 않습니다',
    'settings.password.errMinLen': '최소 8자 필요',
    'settings.password.errSameAsCurrent': '새 비밀번호는 현재와 달라야 합니다',
    'settings.password.errMismatch': '비밀번호가 일치하지 않습니다',
    'settings.password.toastUpdateFailed': '비밀번호를 업데이트할 수 없습니다',
    'settings.password.toastUpdated': '비밀번호가 업데이트되었습니다',
    'settings.password.submit': '비밀번호 업데이트',
    'settings.password.updating': '업데이트 중…',
    'settings.profile.cropPhotoAria': '자를 사진 선택',
    'settings.profile.addNameHint': '아래 양식에 전체 이름을 입력하세요.',
    'settings.profile.activeAccount': '활성 계정',
    'settings.profile.choosePhoto': '사진 선택',
    'settings.profile.working': '처리 중…',
    'settings.profile.removePhoto': '사진 제거',
    'settings.profile.infoTitle': '프로필 정보',
    'settings.profile.fullName': '전체 이름',
    'settings.profile.placeholderFullName': '전체 이름',
    'settings.profile.email': '이메일',
    'settings.profile.emailLockedHint': '이메일은 변경할 수 없습니다',
    'settings.profile.phone': '전화번호',
    'settings.profile.phonePlaceholder': '+82… 또는 숫자만',
    'settings.profile.address': '주소',
    'settings.profile.username': '사용자 이름',
    'settings.profile.saveChanges': '변경 사항 저장',
    'settings.profile.nameRequired': '전체 이름이 필요합니다',
    'settings.profile.updatedToast': '프로필이 업데이트되었습니다',
    'settings.profile.uploadFailed': '업로드 실패',
    'settings.profile.removeFailed': '사진을 제거할 수 없습니다',
    'settings.profile.photoUpdated': '사진이 업데이트되었습니다',
    'settings.profile.photoRemoved': '사진이 제거되었습니다',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': '프로필 사진 자르기',
    'settings.avatarCrop.hint':
      '드래그로 위치 조정, 슬라이더로 확대/축소. 사진은 정사각형으로 저장됩니다.',
    'settings.avatarCrop.zoom': '확대',
    'settings.avatarCrop.zoomAria': '자르기 확대',
    'settings.avatarCrop.savePhoto': '사진 저장',
    'settings.avatarCrop.uploading': '업로드 중…',
    'settings.avatarCrop.toastWaitLoad': '이미지가 로드될 때까지 기다린 후 다시 시도하세요.',
    'settings.avatarCrop.toastCropFail': '이 이미지를 자를 수 없습니다. JPEG 또는 PNG를 시도하세요.',
    'settings.currency': '통화',
    'settings.selectCurrency': '통화 선택',
    'settings.languagePlaceholder': '언어 선택',
    'common.cancel': '취소',
    'common.next': '다음',
    'common.previous': '이전',
    'user.page.transactions': '거래',
    'user.transactions.sectionTitle': '거래 내역',
    'user.transactions.loading': '거래 불러오는 중…',
    'user.transactions.emptyTitle': '거래 없음',
    'user.transactions.emptyHint': '필터를 조정해 보세요',
    'user.transactions.col.date': '날짜 및 시간',
    'user.transactions.col.type': '유형',
    'user.transactions.col.description': '설명',
    'user.transactions.col.amount': '금액',
    'user.transactions.col.status': '상태',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '총 {{total}}건 중 {{from}}–{{to}}건 표시',
    'user.transactions.filter.from': '시작',
    'user.transactions.filter.to': '종료',
    'user.transactions.filter.searchPlaceholder': 'TXID 또는 설명 검색…',
    'user.transactions.filter.all': '전체',
    'user.transactions.filter.deposit': '입금',
    'user.transactions.filter.withdrawal': '출금',
    'user.transactions.filter.investment': '투자',
    'user.transactions.filter.evoucher': 'E바우처',
    'user.transactions.filter.referral': '추천',
    'user.transactions.filter.stopLoss': '스톱로스',
    'user.transactions.badge.deposit': '입금',
    'user.transactions.badge.withdrawal': '출금',
    'user.transactions.badge.investment': '투자',
    'user.transactions.badge.e-voucher': 'E바우처',
    'user.transactions.badge.referral': '추천',
    'user.transactions.badge.bonus': '보너스',
    'user.transactions.badge.stop-loss': '스톱로스',
    'user.transactions.badge.completed': '완료',
    'user.transactions.badge.active': '활성',
    'user.transactions.badge.pending': '대기',
    'user.transactions.badge.confirming': '확인 중',
    'user.transactions.badge.approved': '승인됨',
    'user.transactions.badge.cancelled': '취소됨',
    'user.transactions.badge.rejected': '거절됨',
    'user.transactions.badge.failed': '실패',
    'user.transactions.exportCsv': 'CSV보내기',
    'user.transactions.exportCsvTitle': 'CSV로보내기',
    'user.transactions.exportNoData': '보낼 데이터가 없습니다',
  },

  pt: {
    'user.settings.intro':
      'Atualize o perfil, a segurança e as preferências desta conta.',
    'agent.settings.intro':
      'Atualize o perfil, a segurança e as preferências de exibição desta conta de agente.',
    'settings.tab.profile': 'Perfil',
    'settings.tab.security': 'Segurança',
    'settings.tab.preferences': 'Preferências',
    'settings.shell.loading': 'A carregar definições…',
    'settings.shell.errorTitle': 'Não foi possível carregar as definições',
    'settings.shell.errorHint':
      'Verifique a ligação ou termine sessão e volte a entrar se a sessão expirou.',
    'settings.shell.tryAgain': 'Tentar novamente',
    'settings.shell.sessionExpired': 'Sessão expirada — inicie sessão novamente',
    'settings.shell.loadProfileFailed': 'Não foi possível carregar o perfil',
    'settings.shell.invalidProfile': 'Resposta de perfil inválida',
    'settings.shell.saveFailed': 'Falha ao guardar',
    'settings.notifications.sectionTitle': 'Notificações',
    'settings.notifications.toggle.emailNotifications.label': 'Notificações por e-mail',
    'settings.notifications.toggle.emailNotifications.desc': 'Receber atualizações por e-mail',
    'settings.notifications.toggle.depositAlerts.label': 'Alertas de depósito',
    'settings.notifications.toggle.depositAlerts.desc': 'Aviso quando os depósitos forem confirmados',
    'settings.notifications.toggle.withdrawalAlerts.label': 'Alertas de levantamento',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'Aviso quando o estado do levantamento mudar',
    'settings.notifications.toggle.investmentUpdates.label': 'Atualizações de investimento',
    'settings.notifications.toggle.investmentUpdates.desc': 'Juros mensais e avisos do plano',
    'settings.notifications.toggle.referralAlerts.label': 'Alertas de referência',
    'settings.notifications.toggle.referralAlerts.desc': 'Notificações da atividade de referência',
    'user.settings.preferences.summary':
      '{{enabled}} de {{total}} tipos de alerta por e-mail estão ativos. Abra o diálogo para alterar depósito, levantamento e mais.',
    'user.settings.preferences.manage': 'Gerir preferências de notificação',
    'user.settings.preferences.modalTitle': 'Preferências de notificação',
    'user.settings.preferences.modalHint':
      'Escolha que e-mails da conta enviamos. Pode atualizar quando quiser.',
    'user.settings.preferences.toastNotificationsSaved': 'Preferências de notificação guardadas',
    'user.settings.preferences.saveNotifications': 'Guardar notificações',
    'settings.preferences.toastSaved': 'Preferências guardadas',
    'settings.security.recoveryTitle': 'Frase de recuperação',
    'settings.security.recoveryBefore':
      'A sua frase de 12 palavras foi mostrada uma vez ao criar a conta. Não a armazenamos em texto simples, por isso não pode ser mostrada aqui. Para repor a palavra-passe esquecida, use',
    'settings.security.recoveryAfter': 'com a frase guardada.',
    'settings.security.forgotPasswordLink': 'Esqueci-me da palavra-passe',
    'settings.password.title': 'Alterar palavra-passe',
    'settings.password.current': 'Palavra-passe atual',
    'settings.password.new': 'Nova palavra-passe',
    'settings.password.confirm': 'Confirmar palavra-passe',
    'settings.password.show': 'Mostrar',
    'settings.password.hide': 'Ocultar',
    'settings.password.match': 'As palavras-passe coincidem',
    'settings.password.noMatch': 'As palavras-passe não coincidem',
    'settings.password.errMinLen': 'São necessários pelo menos 8 caracteres',
    'settings.password.errSameAsCurrent': 'A nova palavra-passe deve ser diferente da atual',
    'settings.password.errMismatch': 'As palavras-passe não coincidem',
    'settings.password.toastUpdateFailed': 'Não foi possível atualizar a palavra-passe',
    'settings.password.toastUpdated': 'Palavra-passe atualizada com sucesso',
    'settings.password.submit': 'Atualizar palavra-passe',
    'settings.password.updating': 'A atualizar…',
    'settings.profile.cropPhotoAria': 'Escolher foto para recortar',
    'settings.profile.addNameHint': 'Adicione o seu nome completo no formulário abaixo.',
    'settings.profile.activeAccount': 'Conta ativa',
    'settings.profile.choosePhoto': 'Escolher foto',
    'settings.profile.working': 'A processar…',
    'settings.profile.removePhoto': 'Remover foto',
    'settings.profile.infoTitle': 'Informações do perfil',
    'settings.profile.fullName': 'Nome completo',
    'settings.profile.placeholderFullName': 'O seu nome completo',
    'settings.profile.email': 'E-mail',
    'settings.profile.emailLockedHint': 'O e-mail não pode ser alterado',
    'settings.profile.phone': 'Telefone',
    'settings.profile.phonePlaceholder': '+351… ou apenas dígitos',
    'settings.profile.address': 'Morada',
    'settings.profile.username': 'Nome de utilizador',
    'settings.profile.saveChanges': 'Guardar alterações',
    'settings.profile.nameRequired': 'O nome completo é obrigatório',
    'settings.profile.updatedToast': 'Perfil atualizado com sucesso',
    'settings.profile.uploadFailed': 'Falha no carregamento',
    'settings.profile.removeFailed': 'Não foi possível remover a foto',
    'settings.profile.photoUpdated': 'Foto atualizada',
    'settings.profile.photoRemoved': 'Foto removida',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'Recortar foto de perfil',
    'settings.avatarCrop.hint':
      'Arraste para reposicionar, use o controlo de zoom. A foto é guardada quadrada.',
    'settings.avatarCrop.zoom': 'Zoom',
    'settings.avatarCrop.zoomAria': 'Zoom do recorte',
    'settings.avatarCrop.savePhoto': 'Guardar foto',
    'settings.avatarCrop.uploading': 'A carregar…',
    'settings.avatarCrop.toastWaitLoad': 'Espere que a imagem carregue e tente novamente.',
    'settings.avatarCrop.toastCropFail':
      'Não foi possível recortar esta imagem. Experimente JPEG ou PNG.',
    'settings.currency': 'Moeda',
    'settings.selectCurrency': 'Selecionar moeda',
    'settings.languagePlaceholder': 'Selecionar idioma',
    'common.cancel': 'Cancelar',
    'common.next': 'Seguinte',
    'common.previous': 'Anterior',
    'user.page.transactions': 'Transações',
    'user.transactions.sectionTitle': 'Histórico de transações',
    'user.transactions.loading': 'A carregar transações…',
    'user.transactions.emptyTitle': 'Sem transações',
    'user.transactions.emptyHint': 'Tente ajustar os filtros',
    'user.transactions.col.date': 'Data e hora',
    'user.transactions.col.type': 'Tipo',
    'user.transactions.col.description': 'Descrição',
    'user.transactions.col.amount': 'Montante',
    'user.transactions.col.status': 'Estado',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'A mostrar {{from}}–{{to}} de {{total}} transações',
    'user.transactions.filter.from': 'De',
    'user.transactions.filter.to': 'Até',
    'user.transactions.filter.searchPlaceholder': 'Pesquisar TXID ou descrição…',
    'user.transactions.filter.all': 'Todas',
    'user.transactions.filter.deposit': 'Depósito',
    'user.transactions.filter.withdrawal': 'Levantamento',
    'user.transactions.filter.investment': 'Investimento',
    'user.transactions.filter.evoucher': 'E-Voucher',
    'user.transactions.filter.referral': 'Referência',
    'user.transactions.filter.stopLoss': 'Stop-Loss',
    'user.transactions.badge.deposit': 'Depósito',
    'user.transactions.badge.withdrawal': 'Levantamento',
    'user.transactions.badge.investment': 'Investimento',
    'user.transactions.badge.e-voucher': 'E-Voucher',
    'user.transactions.badge.referral': 'Referência',
    'user.transactions.badge.bonus': 'Bónus',
    'user.transactions.badge.stop-loss': 'Stop-Loss',
    'user.transactions.badge.completed': 'Concluído',
    'user.transactions.badge.active': 'Ativo',
    'user.transactions.badge.pending': 'Pendente',
    'user.transactions.badge.confirming': 'A confirmar',
    'user.transactions.badge.approved': 'Aprovado',
    'user.transactions.badge.cancelled': 'Cancelado',
    'user.transactions.badge.rejected': 'Rejeitado',
    'user.transactions.badge.failed': 'Falhou',
    'user.transactions.exportCsv': 'Exportar CSV',
    'user.transactions.exportCsvTitle': 'Exportar como CSV',
    'user.transactions.exportNoData': 'Sem dados para exportar',
  },

  it: {
    'user.settings.intro':
      'Aggiorna profilo, sicurezza e preferenze per questo account.',
    'agent.settings.intro':
      'Aggiorna profilo, sicurezza e preferenze di visualizzazione per questo account agente.',
    'settings.tab.profile': 'Profilo',
    'settings.tab.security': 'Sicurezza',
    'settings.tab.preferences': 'Preferenze',
    'settings.shell.loading': 'Caricamento impostazioni…',
    'settings.shell.errorTitle': 'Impossibile caricare le impostazioni',
    'settings.shell.errorHint':
      'Controlla la connessione oppure esci e accedi di nuovo se la sessione è scaduta.',
    'settings.shell.tryAgain': 'Riprova',
    'settings.shell.sessionExpired': 'Sessione scaduta — accedi di nuovo',
    'settings.shell.loadProfileFailed': 'Impossibile caricare il profilo',
    'settings.shell.invalidProfile': 'Risposta profilo non valida',
    'settings.shell.saveFailed': 'Salvataggio non riuscito',
    'settings.notifications.sectionTitle': 'Notifiche',
    'settings.notifications.toggle.emailNotifications.label': 'Notifiche e-mail',
    'settings.notifications.toggle.emailNotifications.desc': 'Ricevi aggiornamenti via e-mail',
    'settings.notifications.toggle.depositAlerts.label': 'Avvisi deposito',
    'settings.notifications.toggle.depositAlerts.desc': 'Avviso quando i depositi sono confermati',
    'settings.notifications.toggle.withdrawalAlerts.label': 'Avvisi prelievo',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'Avviso sui cambi di stato del prelievo',
    'settings.notifications.toggle.investmentUpdates.label': 'Aggiornamenti investimenti',
    'settings.notifications.toggle.investmentUpdates.desc': 'Interessi mensili e avvisi sul piano',
    'settings.notifications.toggle.referralAlerts.label': 'Avvisi referral',
    'settings.notifications.toggle.referralAlerts.desc': 'Notifiche sull’attività di referral',
    'user.settings.preferences.summary':
      '{{enabled}} su {{total}} tipi di avviso e-mail sono attivi. Apri la finestra per modificare deposito, prelievo e altro.',
    'user.settings.preferences.manage': 'Gestisci preferenze notifiche',
    'user.settings.preferences.modalTitle': 'Preferenze notifiche',
    'user.settings.preferences.modalHint':
      'Scegli quali e-mail inviamo. Puoi aggiornare in qualsiasi momento.',
    'user.settings.preferences.toastNotificationsSaved': 'Preferenze notifiche salvate',
    'user.settings.preferences.saveNotifications': 'Salva notifiche',
    'settings.preferences.toastSaved': 'Preferenze salvate',
    'settings.security.recoveryTitle': 'Frase di recupero',
    'settings.security.recoveryBefore':
      'La tua frase di 12 parole è stata mostrata una sola volta alla creazione dell’account. Non la memorizziamo in chiaro, quindi non può essere mostrata qui. Per reimpostare la password dimenticata usa',
    'settings.security.recoveryAfter': 'con la frase salvata.',
    'settings.security.forgotPasswordLink': 'Password dimenticata',
    'settings.password.title': 'Cambia password',
    'settings.password.current': 'Password attuale',
    'settings.password.new': 'Nuova password',
    'settings.password.confirm': 'Conferma password',
    'settings.password.show': 'Mostra',
    'settings.password.hide': 'Nascondi',
    'settings.password.match': 'Le password coincidono',
    'settings.password.noMatch': 'Le password non coincidono',
    'settings.password.errMinLen': 'Sono richiesti almeno 8 caratteri',
    'settings.password.errSameAsCurrent': 'La nuova password deve essere diversa da quella attuale',
    'settings.password.errMismatch': 'Le password non coincidono',
    'settings.password.toastUpdateFailed': 'Impossibile aggiornare la password',
    'settings.password.toastUpdated': 'Password aggiornata correttamente',
    'settings.password.submit': 'Aggiorna password',
    'settings.password.updating': 'Aggiornamento…',
    'settings.profile.cropPhotoAria': 'Scegli foto da ritagliare',
    'settings.profile.addNameHint': 'Aggiungi il nome completo nel modulo sotto.',
    'settings.profile.activeAccount': 'Account attivo',
    'settings.profile.choosePhoto': 'Scegli foto',
    'settings.profile.working': 'Elaborazione…',
    'settings.profile.removePhoto': 'Rimuovi foto',
    'settings.profile.infoTitle': 'Informazioni profilo',
    'settings.profile.fullName': 'Nome completo',
    'settings.profile.placeholderFullName': 'Il tuo nome completo',
    'settings.profile.email': 'E-mail',
    'settings.profile.emailLockedHint': 'L’e-mail non può essere modificata',
    'settings.profile.phone': 'Numero di telefono',
    'settings.profile.phonePlaceholder': '+39… o solo cifre',
    'settings.profile.address': 'Indirizzo',
    'settings.profile.username': 'Nome utente',
    'settings.profile.saveChanges': 'Salva modifiche',
    'settings.profile.nameRequired': 'Il nome completo è obbligatorio',
    'settings.profile.updatedToast': 'Profilo aggiornato correttamente',
    'settings.profile.uploadFailed': 'Caricamento non riuscito',
    'settings.profile.removeFailed': 'Impossibile rimuovere la foto',
    'settings.profile.photoUpdated': 'Foto aggiornata',
    'settings.profile.photoRemoved': 'Foto rimossa',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'Ritaglia foto profilo',
    'settings.avatarCrop.hint':
      'Trascina per spostare, usa lo zoom. La foto viene salvata quadrata.',
    'settings.avatarCrop.zoom': 'Zoom',
    'settings.avatarCrop.zoomAria': 'Zoom ritaglio',
    'settings.avatarCrop.savePhoto': 'Salva foto',
    'settings.avatarCrop.uploading': 'Caricamento…',
    'settings.avatarCrop.toastWaitLoad': 'Attendi il caricamento dell’immagine, poi riprova.',
    'settings.avatarCrop.toastCropFail':
      'Impossibile ritagliare questa immagine. Prova JPEG o PNG.',
    'settings.currency': 'Valuta',
    'settings.selectCurrency': 'Seleziona valuta',
    'settings.languagePlaceholder': 'Seleziona lingua',
    'common.cancel': 'Annulla',
    'common.next': 'Avanti',
    'common.previous': 'Indietro',
    'user.page.transactions': 'Transazioni',
    'user.transactions.sectionTitle': 'Cronologia transazioni',
    'user.transactions.loading': 'Caricamento transazioni…',
    'user.transactions.emptyTitle': 'Nessuna transazione',
    'user.transactions.emptyHint': 'Prova a modificare i filtri',
    'user.transactions.col.date': 'Data e ora',
    'user.transactions.col.type': 'Tipo',
    'user.transactions.col.description': 'Descrizione',
    'user.transactions.col.amount': 'Importo',
    'user.transactions.col.status': 'Stato',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'Mostra {{from}}–{{to}} di {{total}} transazioni',
    'user.transactions.filter.from': 'Da',
    'user.transactions.filter.to': 'A',
    'user.transactions.filter.searchPlaceholder': 'Cerca TXID o descrizione…',
    'user.transactions.filter.all': 'Tutte',
    'user.transactions.filter.deposit': 'Deposito',
    'user.transactions.filter.withdrawal': 'Prelievo',
    'user.transactions.filter.investment': 'Investimento',
    'user.transactions.filter.evoucher': 'E-Voucher',
    'user.transactions.filter.referral': 'Referral',
    'user.transactions.filter.stopLoss': 'Stop-Loss',
    'user.transactions.badge.deposit': 'Deposito',
    'user.transactions.badge.withdrawal': 'Prelievo',
    'user.transactions.badge.investment': 'Investimento',
    'user.transactions.badge.e-voucher': 'E-Voucher',
    'user.transactions.badge.referral': 'Referral',
    'user.transactions.badge.bonus': 'Bonus',
    'user.transactions.badge.stop-loss': 'Stop-Loss',
    'user.transactions.badge.completed': 'Completato',
    'user.transactions.badge.active': 'Attivo',
    'user.transactions.badge.pending': 'In attesa',
    'user.transactions.badge.confirming': 'In conferma',
    'user.transactions.badge.approved': 'Approvato',
    'user.transactions.badge.cancelled': 'Annullato',
    'user.transactions.badge.rejected': 'Rifiutato',
    'user.transactions.badge.failed': 'Non riuscito',
    'user.transactions.exportCsv': 'Esporta CSV',
    'user.transactions.exportCsvTitle': 'Esporta come CSV',
    'user.transactions.exportNoData': 'Nessun dato da esportare',
  },

  ru: {
    'user.settings.intro':
      'Обновите профиль, безопасность и настройки этой учётной записи.',
    'agent.settings.intro':
      'Обновите профиль, безопасность и параметры отображения этой учётной записи агента.',
    'settings.tab.profile': 'Профиль',
    'settings.tab.security': 'Безопасность',
    'settings.tab.preferences': 'Настройки',
    'settings.shell.loading': 'Загрузка настроек…',
    'settings.shell.errorTitle': 'Не удалось загрузить настройки',
    'settings.shell.errorHint':
      'Проверьте соединение или выйдите и войдите снова, если сессия истекла.',
    'settings.shell.tryAgain': 'Повторить',
    'settings.shell.sessionExpired': 'Сессия истекла — войдите снова',
    'settings.shell.loadProfileFailed': 'Не удалось загрузить профиль',
    'settings.shell.invalidProfile': 'Некорректный ответ профиля',
    'settings.shell.saveFailed': 'Не удалось сохранить',
    'settings.notifications.sectionTitle': 'Уведомления',
    'settings.notifications.toggle.emailNotifications.label': 'Уведомления по электронной почте',
    'settings.notifications.toggle.emailNotifications.desc': 'Получать обновления по почте',
    'settings.notifications.toggle.depositAlerts.label': 'Оповещения о пополнении',
    'settings.notifications.toggle.depositAlerts.desc': 'Уведомление при подтверждении пополнений',
    'settings.notifications.toggle.withdrawalAlerts.label': 'Оповещения о выводе',
    'settings.notifications.toggle.withdrawalAlerts.desc': 'Уведомление при изменении статуса вывода',
    'settings.notifications.toggle.investmentUpdates.label': 'Обновления по инвестициям',
    'settings.notifications.toggle.investmentUpdates.desc': 'Ежемесячные проценты и уведомления плана',
    'settings.notifications.toggle.referralAlerts.label': 'Реферальные оповещения',
    'settings.notifications.toggle.referralAlerts.desc': 'Уведомления о реферальной активности',
    'user.settings.preferences.summary':
      'Включено {{enabled}} из {{total}} типов почтовых оповещений. Откройте окно, чтобы изменить пополнение, вывод и другое.',
    'user.settings.preferences.manage': 'Управление уведомлениями',
    'user.settings.preferences.modalTitle': 'Настройки уведомлений',
    'user.settings.preferences.modalHint':
      'Выберите, какие письма мы отправляем. Можно изменить в любое время.',
    'user.settings.preferences.toastNotificationsSaved': 'Настройки уведомлений сохранены',
    'user.settings.preferences.saveNotifications': 'Сохранить уведомления',
    'settings.preferences.toastSaved': 'Настройки сохранены',
    'settings.security.recoveryTitle': 'Фраза восстановления',
    'settings.security.recoveryBefore':
      'Ваша 12-словная фраза показывалась один раз при создании аккаунта. Мы не храним её в открытом виде, поэтому её нельзя показать здесь. Чтобы сбросить забытый пароль, используйте',
    'settings.security.recoveryAfter': 'с сохранённой фразой.',
    'settings.security.forgotPasswordLink': 'Забыли пароль',
    'settings.password.title': 'Сменить пароль',
    'settings.password.current': 'Текущий пароль',
    'settings.password.new': 'Новый пароль',
    'settings.password.confirm': 'Подтвердите пароль',
    'settings.password.show': 'Показать',
    'settings.password.hide': 'Скрыть',
    'settings.password.match': 'Пароли совпадают',
    'settings.password.noMatch': 'Пароли не совпадают',
    'settings.password.errMinLen': 'Не менее 8 символов',
    'settings.password.errSameAsCurrent': 'Новый пароль должен отличаться от текущего',
    'settings.password.errMismatch': 'Пароли не совпадают',
    'settings.password.toastUpdateFailed': 'Не удалось обновить пароль',
    'settings.password.toastUpdated': 'Пароль успешно обновлён',
    'settings.password.submit': 'Обновить пароль',
    'settings.password.updating': 'Обновление…',
    'settings.profile.cropPhotoAria': 'Выберите фото для обрезки',
    'settings.profile.addNameHint': 'Укажите полное имя в форме ниже.',
    'settings.profile.activeAccount': 'Активный аккаунт',
    'settings.profile.choosePhoto': 'Выбрать фото',
    'settings.profile.working': 'Обработка…',
    'settings.profile.removePhoto': 'Удалить фото',
    'settings.profile.infoTitle': 'Информация профиля',
    'settings.profile.fullName': 'Полное имя',
    'settings.profile.placeholderFullName': 'Ваше полное имя',
    'settings.profile.email': 'Электронная почта',
    'settings.profile.emailLockedHint': 'Почту нельзя изменить',
    'settings.profile.phone': 'Телефон',
    'settings.profile.phonePlaceholder': '+7… или только цифры',
    'settings.profile.address': 'Адрес',
    'settings.profile.username': 'Имя пользователя',
    'settings.profile.saveChanges': 'Сохранить изменения',
    'settings.profile.nameRequired': 'Требуется полное имя',
    'settings.profile.updatedToast': 'Профиль успешно обновлён',
    'settings.profile.uploadFailed': 'Не удалось загрузить',
    'settings.profile.removeFailed': 'Не удалось удалить фото',
    'settings.profile.photoUpdated': 'Фото обновлено',
    'settings.profile.photoRemoved': 'Фото удалено',
    'settings.profile.avatarFallbackLetter': '?',
    'user.profile.cropPhotoTitle': 'Обрезать фото профиля',
    'settings.avatarCrop.hint':
      'Перетащите для позиции, ползунок — масштаб. Фото сохраняется квадратным.',
    'settings.avatarCrop.zoom': 'Масштаб',
    'settings.avatarCrop.zoomAria': 'Масштаб обрезки',
    'settings.avatarCrop.savePhoto': 'Сохранить фото',
    'settings.avatarCrop.uploading': 'Загрузка…',
    'settings.avatarCrop.toastWaitLoad': 'Дождитесь загрузки изображения и повторите.',
    'settings.avatarCrop.toastCropFail':
      'Не удалось обрезать изображение. Попробуйте JPEG или PNG.',
    'settings.currency': 'Валюта',
    'settings.selectCurrency': 'Выберите валюту',
    'settings.languagePlaceholder': 'Выберите язык',
    'common.cancel': 'Отмена',
    'common.next': 'Далее',
    'common.previous': 'Назад',
    'user.page.transactions': 'Транзакции',
    'user.transactions.sectionTitle': 'История транзакций',
    'user.transactions.loading': 'Загрузка транзакций…',
    'user.transactions.emptyTitle': 'Транзакций нет',
    'user.transactions.emptyHint': 'Попробуйте изменить фильтры',
    'user.transactions.col.date': 'Дата и время',
    'user.transactions.col.type': 'Тип',
    'user.transactions.col.description': 'Описание',
    'user.transactions.col.amount': 'Сумма',
    'user.transactions.col.status': 'Статус',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': 'Показано {{from}}–{{to}} из {{total}} транзакций',
    'user.transactions.filter.from': 'С',
    'user.transactions.filter.to': 'По',
    'user.transactions.filter.searchPlaceholder': 'Поиск TXID или описания…',
    'user.transactions.filter.all': 'Все',
    'user.transactions.filter.deposit': 'Пополнение',
    'user.transactions.filter.withdrawal': 'Вывод',
    'user.transactions.filter.investment': 'Инвестиция',
    'user.transactions.filter.evoucher': 'E-ваучер',
    'user.transactions.filter.referral': 'Реферал',
    'user.transactions.filter.stopLoss': 'Стоп-лосс',
    'user.transactions.badge.deposit': 'Пополнение',
    'user.transactions.badge.withdrawal': 'Вывод',
    'user.transactions.badge.investment': 'Инвестиция',
    'user.transactions.badge.e-voucher': 'E-ваучер',
    'user.transactions.badge.referral': 'Реферал',
    'user.transactions.badge.bonus': 'Бонус',
    'user.transactions.badge.stop-loss': 'Стоп-лосс',
    'user.transactions.badge.completed': 'Завершено',
    'user.transactions.badge.active': 'Активно',
    'user.transactions.badge.pending': 'В ожидании',
    'user.transactions.badge.confirming': 'Подтверждение',
    'user.transactions.badge.approved': 'Одобрено',
    'user.transactions.badge.cancelled': 'Отменено',
    'user.transactions.badge.rejected': 'Отклонено',
    'user.transactions.badge.failed': 'Ошибка',
    'user.transactions.exportCsv': 'Экспорт CSV',
    'user.transactions.exportCsvTitle': 'Экспорт в CSV',
    'user.transactions.exportNoData': 'Нет данных для экспорта',
  },

  'zh-CN': {
    'user.settings.intro': '更新此账户的个人资料、安全与偏好设置。',
    'agent.settings.intro': '更新此代理账户的个人资料、安全与显示偏好。',
    'settings.tab.profile': '个人资料',
    'settings.tab.security': '安全',
    'settings.tab.preferences': '偏好设置',
    'settings.shell.loading': '正在加载设置…',
    'settings.shell.errorTitle': '无法加载设置',
    'settings.shell.errorHint': '请检查网络连接，或若会话已过期请重新登录。',
    'settings.shell.tryAgain': '重试',
    'settings.shell.sessionExpired': '会话已过期 — 请重新登录',
    'settings.shell.loadProfileFailed': '无法加载个人资料',
    'settings.shell.invalidProfile': '无效的个人资料响应',
    'settings.shell.saveFailed': '保存失败',
    'settings.notifications.sectionTitle': '通知',
    'settings.notifications.toggle.emailNotifications.label': '邮件通知',
    'settings.notifications.toggle.emailNotifications.desc': '通过电子邮件接收更新',
    'settings.notifications.toggle.depositAlerts.label': '充值提醒',
    'settings.notifications.toggle.depositAlerts.desc': '充值确认后通知',
    'settings.notifications.toggle.withdrawalAlerts.label': '提现提醒',
    'settings.notifications.toggle.withdrawalAlerts.desc': '提现状态变更时通知',
    'settings.notifications.toggle.investmentUpdates.label': '投资更新',
    'settings.notifications.toggle.investmentUpdates.desc': '月度利息与计划通知',
    'settings.notifications.toggle.referralAlerts.label': '推荐提醒',
    'settings.notifications.toggle.referralAlerts.desc': '推荐活动通知',
    'user.settings.preferences.summary':
      '已开启 {{enabled}} / {{total}} 种邮件提醒。打开对话框可更改充值、提现等设置。',
    'user.settings.preferences.manage': '管理通知偏好',
    'user.settings.preferences.modalTitle': '通知偏好',
    'user.settings.preferences.modalHint': '选择我们发送的账户邮件。可随时更改。',
    'user.settings.preferences.toastNotificationsSaved': '已保存通知偏好',
    'user.settings.preferences.saveNotifications': '保存通知',
    'settings.preferences.toastSaved': '偏好已保存',
    'settings.security.recoveryTitle': '恢复短语',
    'settings.security.recoveryBefore':
      '您的 12 个词短语仅在创建账户时显示一次。我们不会以明文存储，因此无法在此显示。若忘记密码，请使用',
    'settings.security.recoveryAfter': '并配合您保存的短语。',
    'settings.security.forgotPasswordLink': '忘记密码',
    'settings.password.title': '更改密码',
    'settings.password.current': '当前密码',
    'settings.password.new': '新密码',
    'settings.password.confirm': '确认密码',
    'settings.password.show': '显示',
    'settings.password.hide': '隐藏',
    'settings.password.match': '密码一致',
    'settings.password.noMatch': '密码不一致',
    'settings.password.errMinLen': '至少需要 8 个字符',
    'settings.password.errSameAsCurrent': '新密码必须与当前密码不同',
    'settings.password.errMismatch': '密码不一致',
    'settings.password.toastUpdateFailed': '无法更新密码',
    'settings.password.toastUpdated': '密码已更新',
    'settings.password.submit': '更新密码',
    'settings.password.updating': '正在更新…',
    'settings.profile.cropPhotoAria': '选择要裁剪的照片',
    'settings.profile.addNameHint': '在下方表单填写您的全名。',
    'settings.profile.activeAccount': '活跃账户',
    'settings.profile.choosePhoto': '选择照片',
    'settings.profile.working': '处理中…',
    'settings.profile.removePhoto': '移除照片',
    'settings.profile.infoTitle': '个人资料信息',
    'settings.profile.fullName': '全名',
    'settings.profile.placeholderFullName': '您的全名',
    'settings.profile.email': '电子邮件',
    'settings.profile.emailLockedHint': '电子邮件不可更改',
    'settings.profile.phone': '电话号码',
    'settings.profile.phonePlaceholder': '+86… 或仅数字',
    'settings.profile.address': '地址',
    'settings.profile.username': '用户名',
    'settings.profile.saveChanges': '保存更改',
    'settings.profile.nameRequired': '必须填写全名',
    'settings.profile.updatedToast': '个人资料已更新',
    'settings.profile.uploadFailed': '上传失败',
    'settings.profile.removeFailed': '无法移除照片',
    'settings.profile.photoUpdated': '照片已更新',
    'settings.profile.photoRemoved': '照片已移除',
    'settings.profile.avatarFallbackLetter': '？',
    'user.profile.cropPhotoTitle': '裁剪头像',
    'settings.avatarCrop.hint': '拖动调整位置，滑块缩放。照片将保存为正方形。',
    'settings.avatarCrop.zoom': '缩放',
    'settings.avatarCrop.zoomAria': '裁剪缩放',
    'settings.avatarCrop.savePhoto': '保存照片',
    'settings.avatarCrop.uploading': '上传中…',
    'settings.avatarCrop.toastWaitLoad': '请等待图片加载完成后再试。',
    'settings.avatarCrop.toastCropFail': '无法裁剪此图片。请尝试 JPEG 或 PNG。',
    'settings.currency': '货币',
    'settings.selectCurrency': '选择货币',
    'settings.languagePlaceholder': '选择语言',
    'common.cancel': '取消',
    'common.next': '下一页',
    'common.previous': '上一页',
    'user.page.transactions': '交易',
    'user.transactions.sectionTitle': '交易记录',
    'user.transactions.loading': '正在加载交易…',
    'user.transactions.emptyTitle': '暂无交易',
    'user.transactions.emptyHint': '请尝试调整筛选条件',
    'user.transactions.col.date': '日期与时间',
    'user.transactions.col.type': '类型',
    'user.transactions.col.description': '说明',
    'user.transactions.col.amount': '金额',
    'user.transactions.col.status': '状态',
    'user.transactions.col.txid': 'TXID',
    'user.transactions.showing': '显示第 {{from}}–{{to}} 条，共 {{total}} 条交易',
    'user.transactions.filter.from': '从',
    'user.transactions.filter.to': '至',
    'user.transactions.filter.searchPlaceholder': '搜索 TXID 或说明…',
    'user.transactions.filter.all': '全部',
    'user.transactions.filter.deposit': '充值',
    'user.transactions.filter.withdrawal': '提现',
    'user.transactions.filter.investment': '投资',
    'user.transactions.filter.evoucher': '电子券',
    'user.transactions.filter.referral': '推荐',
    'user.transactions.filter.stopLoss': '止损',
    'user.transactions.badge.deposit': '充值',
    'user.transactions.badge.withdrawal': '提现',
    'user.transactions.badge.investment': '投资',
    'user.transactions.badge.e-voucher': '电子券',
    'user.transactions.badge.referral': '推荐',
    'user.transactions.badge.bonus': '奖金',
    'user.transactions.badge.stop-loss': '止损',
    'user.transactions.badge.completed': '已完成',
    'user.transactions.badge.active': '进行中',
    'user.transactions.badge.pending': '待处理',
    'user.transactions.badge.confirming': '确认中',
    'user.transactions.badge.approved': '已批准',
    'user.transactions.badge.cancelled': '已取消',
    'user.transactions.badge.rejected': '已拒绝',
    'user.transactions.badge.failed': '失败',
    'user.transactions.exportCsv': '导出 CSV',
    'user.transactions.exportCsvTitle': '导出为 CSV',
    'user.transactions.exportNoData': '没有可导出的数据',
  },
};

/** Page titles, referral, ranking UI, stop-loss copy — merged per locale after settings/transactions. */
export const panelUserExtraByLang = {
  de: {
    'site.docTitle': '{{page}} | MineMe — Hochrentable Anlageplattform',
    'site.brandLine': 'MineMe — Hochrentable Anlageplattform',
    'user.page.investments': 'Investitionen',
    'user.page.transactions': 'Transaktionen',
    'user.page.stopLoss': 'Stop-Loss',
    'user.page.referral': 'Empfehlung',
    'user.page.settings': 'Einstellungen',
    'user.page.deposit': 'Einzahlung',
    'user.page.withdraw': 'Auszahlung',
    'user.dashboard.title': 'Dashboard',
    'user.deposit.title': 'Einzahlung',
    'user.withdraw.title': 'Auszahlung',
    'user.investments.tab.browse': 'Pläne durchsuchen',
    'user.investments.tab.active': 'Aktive Investitionen',
    'user.investments.tab.history': 'Verlauf',
    'user.empty.noStopLoss': 'Kein aktiver Stop-Loss-Schutz',
    'user.referral.link.title': 'Ihr Empfehlungslink',
    'user.referral.link.loading': 'Link wird geladen…',
    'user.referral.link.hint': 'Laden Sie Freunde mit Ihrem persönlichen Link zu MineMe ein.',
    'user.referral.link.hintLong':
      'Laden Sie Freunde mit Ihrem persönlichen Link zu MineMe ein und helfen Sie, das Netzwerk zu vergrößern.',
    'user.referral.link.share': 'Teilen',
    'user.referral.link.shareTitle': 'Mit meinem Empfehlungslink beitreten',
    'user.referral.stats.direct': 'Direkte Empfehlungen',
    'user.referral.stats.indirect': 'Indirekte Empfehlungen',
    'user.referral.tree.title': 'Ihr Empfehlungsnetzwerk',
    'user.referral.tree.loading': 'Netzwerk wird geladen…',
    'user.referral.tree.you': 'Sie',
    'user.referral.tree.directLevel': 'Direkte Ebene',
    'user.referral.tree.indirectLevel': 'Indirekte Ebene',
    'user.referral.tree.noDirect': 'Noch keine direkten Empfehlungen',
    'user.referral.tree.noIndirect': 'Noch keine indirekten Empfehlungen',
    'user.referral.tree.directCount': '{{n}} direkte Empfehlungen',
    'user.referral.tree.indirectCount': '{{n}} indirekte Empfehlungen',
    'user.referral.tree.more': '+{{n}} weitere',
    'user.referral.ranking.tableTitle': 'Ranking-System',
    'user.referral.ranking.loading': 'Rankings werden geladen…',
    'user.referral.ranking.loadError':
      'Rankings konnten nicht geladen werden. Seite neu laden oder später erneut versuchen.',
    'user.referral.ranking.col.rank': 'Rang',
    'user.referral.ranking.col.minDeposit': 'Mindesteinzahlung',
    'user.referral.ranking.col.monthlyIncome': 'Monatliches Einkommen',
    'user.referral.ranking.col.directRefs': 'Direkte Refs',
    'user.referral.ranking.col.extraCommission': 'Zusätzliche Provision',
    'user.referral.ranking.badgeYou': 'Sie',
    'user.referral.rankingRewards.title': 'Ranking-Prämien',
    'user.referral.rankingRewards.loading': 'Ranking-Fortschritt wird geladen…',
    'user.referral.rankingRewards.engineDisabled':
      'Die Ranking-Prämien sind derzeit durch den Administrator deaktiviert.',
    'user.referral.rankingRewards.notInScope':
      'Ranking-Prämien sind für Ihren Kontotyp gemäß den aktuellen Plattformeinstellungen nicht verfügbar.',
    'user.referral.rankingRewards.disqualified':
      'Ihr {{days}}-Tage-Aktivierungsfenster ist abgelaufen, bevor Sie die Einstiegsstufe erreicht haben; künftige Ranking-Prämien sind nicht mehr verfügbar.',
    'user.referral.rankingRewards.daysLeftOne': 'Noch {{days}} Tag zur Aktivierung',
    'user.referral.rankingRewards.daysLeftMany': 'Noch {{days}} Tage zur Aktivierung',
    'user.referral.rankingRewards.activationClosingToday': 'Aktivierungsfenster endet heute',
    'user.referral.rankingRewards.activationHint':
      'Erreichen Sie die Einstiegsstufe innerhalb von {{days}} Tagen nach der Registrierung (Frist {{deadline}}). Tag 1 beginnt mit der Anmeldung. Direkte UND indirekte Kriterien müssen erfüllt sein.',
    'user.referral.rankingRewards.activatedBanner':
      'Aktiviert. Werben Sie weiter, um höhere Stufen freizuschalten — jede wird einmal vergeben, wenn direkte und indirekte Kriterien erfüllt sind.',
    'user.referral.rankingRewards.windowBadge': '{{days}}-Tage-Fenster',
    'user.referral.rankingRewards.earnedSummary': '{{amount}} über {{count}} Stufe verdient',
    'user.referral.rankingRewards.earnedSummaryPlural': '{{amount}} über {{count}} Stufen verdient',
    'user.referral.rankingRewards.col.tier': 'Stufe',
    'user.referral.rankingRewards.col.reward': 'Prämie',
    'user.referral.rankingRewards.col.awarded': 'Vergeben',
    'user.referral.currentRank.title': 'Aktueller Rang',
    'user.referral.currentRank.loading': 'Ihr Rang wird geladen…',
    'user.referral.currentRank.topRank': 'Höchster Rang',
    'user.referral.currentRank.targets': '{{rank}} Ziele',
    'user.referral.currentRank.topCongratulations': 'Sie haben den höchsten Rang — Glückwunsch.',
    'user.referral.currentRank.directMore': 'noch {{n}} direkte',
    'user.referral.currentRank.directMorePlural': 'noch {{n}} direkte',
    'user.referral.currentRank.indirectMore': 'noch {{n}} indirekte',
    'user.referral.currentRank.indirectMorePlural': 'noch {{n}} indirekte',
    'user.referral.currentRank.readyUnlock': 'Bereit, {{rank}} bei der nächsten Auswertung freizuschalten.',
    'user.referral.currentRank.remainingJoin': '{{parts}} bis {{rank}}.',
    'user.referral.currentRank.noTiers': 'Keine Rangstufen konfiguriert',
    'user.referral.currentRank.pillTop': 'Aktiv — Höchster Rang erreicht',
    'user.referral.currentRank.pillActive': 'Aktiv',
    'user.referral.currentRank.pillStarter': 'Startrang — Ziele erreichen, um die Stufenprämie zu erhalten',
    'user.referral.currentRank.lastReward': 'Zuletzt erhaltene Stufenprämie:',
    'user.referral.currentRank.bonusHeading': '{{rank}}-Bonus',
    'user.referral.currentRank.progressLine':
      '{{directHave}}/{{directNeed}} direkt · {{indirectHave}}/{{indirectNeed}} indirekt',
    'user.stopLoss.planType.silver': 'Silber',
    'user.stopLoss.planType.gold': 'Gold',
    'user.stopLoss.planType.platinum': 'Platin',
    'user.stopLoss.feature.slotOneInvestment': '1 Slot für 1 Investition',
    'user.stopLoss.feature.manualValuationUpdates': 'Manuelle Bewertungsupdates durch den Admin',
    'user.stopLoss.feature.nonRefundableSlot': 'Nicht erstattbarer Slot-Kauf',
    'user.stopLoss.feature.flexibleLimits': 'Flexible Prozent- oder Festbetragsgrenzen',
    'user.stopLoss.feature.limitAdjustable': 'Limit vor Auslösung anpassbar',
    'user.stopLoss.feature.priorityMonitoring': 'Prioritätsüberwachung im Admin-Dashboard',
    'user.stopLoss.feature.immediateClose': 'Sofortige Schließung bei Überschreitung des Limits',
    'user.stopLoss.feature.fixedAmountThreshold': 'Fester Betragsschwellenwert',
    'user.stopLoss.feature.emailAlerts': 'E-Mail-Benachrichtigungen',
    'user.stopLoss.feature.manualReview': 'Manuelle Prüfung',
    'user.stopLoss.feature.fixedOrPctThreshold': 'Fester oder %-Schwellenwert',
    'user.stopLoss.feature.priorityAlerts': 'Prioritätswarnungen',
    'user.stopLoss.feature.autoTrigger': 'Auto-Auslösung',
    'user.stopLoss.feature.autoTriggerReport': 'Auto-Auslösung + Bericht',
    'user.stopLoss.feature.advancedThreshold': 'Erweiterte Schwellenoptionen',
    'user.stopLoss.feature.instantAlerts': 'Sofortwarnungen',
    'user.stopLoss.feature.legacyBasicDesc': 'Grundlegender Schutz für Einsteiger',
    'user.stopLoss.feature.legacyStandardDesc': 'Erweiterter Schutz für aktive Anleger',
    'user.stopLoss.feature.legacyFullDesc': 'Maximaler Schutz für große Portfolios',
    'user.stopLoss.pkg.silver.label': 'Silber-Schild',
    'user.stopLoss.pkg.silver.desc': 'Schützen Sie eine Investition mit moderatem Drawdown-Limit.',
    'user.stopLoss.pkg.gold.label': 'Gold-Schild',
    'user.stopLoss.pkg.gold.desc': 'Stop-Loss-Slot höherer Stufe für stärkeren Abwärtsschutz.',
    'user.stopLoss.pkg.platinum.label': 'Platin-Schild',
    'user.stopLoss.pkg.platinum.desc': 'Top-Schutz-Slot für Premium-Portfolios.',
    'user.stopLoss.pkg.basic.label': 'Basis-Schutz',
    'user.stopLoss.pkg.basic.desc': 'Grundlegender Schutz für Einsteiger',
    'user.stopLoss.pkg.standard.label': 'Standard-Schutz',
    'user.stopLoss.pkg.standard.desc': 'Erweiterter Schutz für aktive Anleger',
    'user.stopLoss.pkg.full.label': 'Voll-Schutz',
    'user.stopLoss.pkg.full.desc': 'Maximaler Schutz für große Portfolios',
    'user.stopLoss.yourProtection': 'Ihr aktiver Schutz',
    'user.stopLoss.activePackages': 'Aktive Stop-Loss-Pakete',
    'user.stopLoss.live': 'Live',
    'user.stopLoss.subtitleOne': '1 Paket schützt derzeit Ihr Portfolio.',
    'user.stopLoss.subtitleMany': '{{n}} Pakete sind derzeit aktiv.',
    'user.stopLoss.loadingTable': 'Laden…',
    'user.stopLoss.emptyDescNoSlots': 'Kaufen und weisen Sie unten ein Paket zu, um Ihre Investitionen zu schützen.',
    'user.stopLoss.emptyDescWaiting': 'Sie haben {{count}} gekaufte Slot(s), die auf Zuweisung warten.',
    'user.stopLoss.explainer.title': 'Was ist Stop-Loss-Schutz?',
    'user.stopLoss.explainer.body':
      'Stop-Loss beendet Ihre Investition automatisch, wenn der Wert unter einen von Ihnen festgelegten Schwellenwert fällt und schützt so Ihr Kapital vor plötzlichen Marktrücksetzern und Volatilität.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Nicht erstattbare Zahlung',
    'user.stopLoss.explainer.badge.multi': 'Mehrere Pakete erlaubt',
    'user.stopLoss.explainer.badge.monitoring': 'Automatisierte 24/7-Überwachung',
    'user.stopLoss.how.title': 'So funktioniert Stop-Loss',
    'user.stopLoss.how.step1Title': 'Paket kaufen',
    'user.stopLoss.how.step1Desc': 'Wählen Sie aus 500 $, 1.200 $ oder 2.000 $ Schutzpaketen',
    'user.stopLoss.how.step2Title': 'Schwelle setzen',
    'user.stopLoss.how.step2Desc': 'Legen Sie einen festen Dollarbetrag oder prozentuales Verlustlimit fest',
    'user.stopLoss.how.step3Title': '24/7-Überwachung',
    'user.stopLoss.how.step3Desc': 'Das System überwacht kontinuierlich Ihren Investitionswert',
    'user.stopLoss.how.step4Title': 'Auto-Auslösung',
    'user.stopLoss.how.step4Desc': 'Investition stoppt automatisch, wenn der Wert Ihre Schwelle überschreitet',
    'user.stopLoss.slots.title': 'Meine Stop-Loss-Slots',
    'user.stopLoss.slots.paidPremium': '{{price}} gezahlt · {{premium}} % Prämie',
    'user.stopLoss.slots.purchasedOn': 'Gekauft am {{date}}',
    'user.stopLoss.slots.st.unassigned': 'Nicht zugewiesen',
  },
  es: {
    'site.docTitle': '{{page}} | MineMe — Plataforma de inversión de alto rendimiento',
    'site.brandLine': 'MineMe — Plataforma de inversión de alto rendimiento',
    'user.page.investments': 'Inversiones',
    'user.page.transactions': 'Transacciones',
    'user.page.stopLoss': 'Stop-Loss',
    'user.page.referral': 'Referidos',
    'user.page.settings': 'Ajustes',
    'user.page.deposit': 'Depósito',
    'user.page.withdraw': 'Retiro',
    'user.dashboard.title': 'Panel',
    'user.deposit.title': 'Depósito',
    'user.withdraw.title': 'Retiro',
    'user.investments.tab.browse': 'Explorar planes',
    'user.investments.tab.active': 'Inversiones activas',
    'user.investments.tab.history': 'Historial',
    'user.empty.noStopLoss': 'Sin protección Stop-Loss activa',
    'user.referral.link.title': 'Tu enlace de referido',
    'user.referral.link.loading': 'Cargando enlace…',
    'user.referral.link.hint': 'Invita amigos a MineMe con tu enlace personal.',
    'user.referral.link.hintLong':
      'Invita amigos a MineMe con tu enlace personal y ayuda a crecer la red.',
    'user.referral.link.share': 'Compartir',
    'user.referral.link.shareTitle': 'Únete con mi enlace de referido',
    'user.referral.stats.direct': 'Referidos directos',
    'user.referral.stats.indirect': 'Referidos indirectos',
    'user.referral.tree.title': 'Tu red de referidos',
    'user.referral.tree.loading': 'Cargando red…',
    'user.referral.tree.you': 'Tú',
    'user.referral.tree.directLevel': 'Nivel directo',
    'user.referral.tree.indirectLevel': 'Nivel indirecto',
    'user.referral.tree.noDirect': 'Aún no hay referidos directos',
    'user.referral.tree.noIndirect': 'Aún no hay referidos indirectos',
    'user.referral.tree.directCount': '{{n}} referidos directos',
    'user.referral.tree.indirectCount': '{{n}} referidos indirectos',
    'user.referral.tree.more': '+{{n}} más',
    'user.referral.ranking.tableTitle': 'Sistema de ranking',
    'user.referral.ranking.loading': 'Cargando rankings…',
    'user.referral.ranking.loadError':
      'No se pudieron cargar los rankings. Actualiza la página o inténtalo más tarde.',
    'user.referral.ranking.col.rank': 'Rango',
    'user.referral.ranking.col.minDeposit': 'Depósito mín.',
    'user.referral.ranking.col.monthlyIncome': 'Ingreso mensual',
    'user.referral.ranking.col.directRefs': 'Refs directos',
    'user.referral.ranking.col.extraCommission': 'Comisión extra',
    'user.referral.ranking.badgeYou': 'Tú',
    'user.referral.rankingRewards.title': 'Recompensas de ranking',
    'user.referral.rankingRewards.loading': 'Cargando progreso de ranking…',
    'user.referral.rankingRewards.engineDisabled':
      'El motor de recompensas de ranking está desactivado por el administrador.',
    'user.referral.rankingRewards.notInScope':
      'Las recompensas de ranking no están disponibles para tu tipo de cuenta según la configuración actual.',
    'user.referral.rankingRewards.disqualified':
      'Tu ventana de activación de {{days}} días expiró antes de alcanzar el nivel de entrada, por lo que ya no hay recompensas de ranking.',
    'user.referral.rankingRewards.daysLeftOne': 'Queda {{days}} día para activar',
    'user.referral.rankingRewards.daysLeftMany': 'Quedan {{days}} días para activar',
    'user.referral.rankingRewards.activationClosingToday': 'La ventana de activación cierra hoy',
    'user.referral.rankingRewards.activationHint':
      'Alcanza el nivel de entrada en {{days}} días desde el registro (plazo {{deadline}}). El día 1 comienza al registrarte. Debes cumplir criterios directos E indirectos.',
    'user.referral.rankingRewards.activatedBanner':
      'Activado. Sigue reclutando para desbloquear niveles superiores: cada uno se otorga una vez cuando se cumplen ambos criterios.',
    'user.referral.rankingRewards.windowBadge': 'Ventana de {{days}} días',
    'user.referral.rankingRewards.earnedSummary': 'Ganado {{amount}} en {{count}} nivel',
    'user.referral.rankingRewards.earnedSummaryPlural': 'Ganado {{amount}} en {{count}} niveles',
    'user.referral.rankingRewards.col.tier': 'Nivel',
    'user.referral.rankingRewards.col.reward': 'Recompensa',
    'user.referral.rankingRewards.col.awarded': 'Otorgado',
    'user.referral.currentRank.title': 'Rango actual',
    'user.referral.currentRank.loading': 'Cargando tu rango…',
    'user.referral.currentRank.topRank': 'Rango máximo',
    'user.referral.currentRank.targets': 'Objetivos de {{rank}}',
    'user.referral.currentRank.topCongratulations': 'Estás en el rango máximo — enhorabuena.',
    'user.referral.currentRank.directMore': '{{n}} directo más',
    'user.referral.currentRank.directMorePlural': '{{n}} directos más',
    'user.referral.currentRank.indirectMore': '{{n}} indirecto más',
    'user.referral.currentRank.indirectMorePlural': '{{n}} indirectos más',
    'user.referral.currentRank.readyUnlock': 'Listo para desbloquear {{rank}} en la próxima evaluación.',
    'user.referral.currentRank.remainingJoin': '{{parts}} para alcanzar {{rank}}.',
    'user.referral.currentRank.noTiers': 'No hay niveles de rango configurados',
    'user.referral.currentRank.pillTop': 'Activo — Rango máximo alcanzado',
    'user.referral.currentRank.pillActive': 'Activo',
    'user.referral.currentRank.pillStarter': 'Rango inicial — cumple objetivos para ganar la recompensa',
    'user.referral.currentRank.lastReward': 'Última recompensa de nivel:',
    'user.referral.currentRank.bonusHeading': 'Bonus {{rank}}',
    'user.referral.currentRank.progressLine':
      '{{directHave}}/{{directNeed}} directos · {{indirectHave}}/{{indirectNeed}} indirectos',
    'user.stopLoss.planType.silver': 'Plata',
    'user.stopLoss.planType.gold': 'Oro',
    'user.stopLoss.planType.platinum': 'Platino',
    'user.stopLoss.feature.slotOneInvestment': '1 cupo para 1 inversión',
    'user.stopLoss.feature.manualValuationUpdates': 'Actualizaciones de valoración manuales por el admin',
    'user.stopLoss.feature.nonRefundableSlot': 'Compra de cupo no reembolsable',
    'user.stopLoss.feature.flexibleLimits': 'Límites flexibles en % o valor fijo',
    'user.stopLoss.feature.limitAdjustable': 'El límite se puede ajustar antes del disparo',
    'user.stopLoss.feature.priorityMonitoring': 'Monitoreo prioritario en el panel de admin',
    'user.stopLoss.feature.immediateClose': 'Cierre inmediato al cruzar el límite',
    'user.stopLoss.feature.fixedAmountThreshold': 'Umbral de importe fijo',
    'user.stopLoss.feature.emailAlerts': 'Alertas por correo',
    'user.stopLoss.feature.manualReview': 'Revisión manual',
    'user.stopLoss.feature.fixedOrPctThreshold': 'Umbral fijo o %',
    'user.stopLoss.feature.priorityAlerts': 'Alertas prioritarias',
    'user.stopLoss.feature.autoTrigger': 'Disparo automático',
    'user.stopLoss.feature.autoTriggerReport': 'Disparo automático + informe',
    'user.stopLoss.feature.advancedThreshold': 'Opciones avanzadas de umbral',
    'user.stopLoss.feature.instantAlerts': 'Alertas instantáneas',
    'user.stopLoss.feature.legacyBasicDesc': 'Protección esencial para quien empieza',
    'user.stopLoss.feature.legacyStandardDesc': 'Cobertura ampliada para traders activos',
    'user.stopLoss.feature.legacyFullDesc': 'Máxima protección para carteras grandes',
    'user.stopLoss.pkg.silver.label': 'Escudo Plata',
    'user.stopLoss.pkg.silver.desc': 'Protege una inversión con un límite moderado de caída.',
    'user.stopLoss.pkg.gold.label': 'Escudo Oro',
    'user.stopLoss.pkg.gold.desc': 'Cupo stop-loss de mayor nivel para una protección bajista más fuerte.',
    'user.stopLoss.pkg.platinum.label': 'Escudo Platino',
    'user.stopLoss.pkg.platinum.desc': 'Cupo de protección top para carteras premium.',
    'user.stopLoss.pkg.basic.label': 'Protección Básica',
    'user.stopLoss.pkg.basic.desc': 'Protección esencial para quien empieza',
    'user.stopLoss.pkg.standard.label': 'Protección Estándar',
    'user.stopLoss.pkg.standard.desc': 'Cobertura ampliada para traders activos',
    'user.stopLoss.pkg.full.label': 'Protección Total',
    'user.stopLoss.pkg.full.desc': 'Máxima protección para carteras grandes',
    'user.stopLoss.yourProtection': 'Tu protección activa',
    'user.stopLoss.activePackages': 'Paquetes Stop-Loss activos',
    'user.stopLoss.live': 'En vivo',
    'user.stopLoss.subtitleOne': '1 paquete está protegiendo tu cartera.',
    'user.stopLoss.subtitleMany': '{{n}} paquetes están activos.',
    'user.stopLoss.loadingTable': 'Cargando…',
    'user.stopLoss.emptyDescNoSlots': 'Compra y asigna un paquete abajo para proteger tus inversiones.',
    'user.stopLoss.emptyDescWaiting': 'Tienes {{count}} cupo(s) comprado(s) pendientes de asignación.',
    'user.stopLoss.explainer.title': '¿Qué es la protección Stop-Loss?',
    'user.stopLoss.explainer.body':
      'El stop-loss finaliza automáticamente tu inversión si su valor cae por debajo de un umbral que definas, protegiendo tu capital ante caídas bruscas del mercado y la volatilidad.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Pago no reembolsable',
    'user.stopLoss.explainer.badge.multi': 'Se permiten varios paquetes',
    'user.stopLoss.explainer.badge.monitoring': 'Supervisión automática 24/7',
    'user.stopLoss.how.title': 'Cómo funciona Stop-Loss',
    'user.stopLoss.how.step1Title': 'Comprar paquete',
    'user.stopLoss.how.step1Desc': 'Elige entre paquetes de 500 $, 1.200 $ o 2.000 $',
    'user.stopLoss.how.step2Title': 'Definir umbral',
    'user.stopLoss.how.step2Desc': 'Define un importe fijo en dólares o un límite de pérdida en %',
    'user.stopLoss.how.step3Title': 'Supervisión 24/7',
    'user.stopLoss.how.step3Desc': 'El sistema supervisa continuamente el valor de tu inversión',
    'user.stopLoss.how.step4Title': 'Disparo automático',
    'user.stopLoss.how.step4Desc': 'La inversión se detiene sola si el valor cruza tu umbral',
    'user.stopLoss.slots.title': 'Mis cupos Stop-Loss',
    'user.stopLoss.slots.paidPremium': '{{price}} pagados · {{premium}} % de prima',
    'user.stopLoss.slots.purchasedOn': 'Comprado el {{date}}',
    'user.stopLoss.slots.st.unassigned': 'Sin asignar',
  },

  fr: {
    'site.docTitle': '{{page}} | MineMe — Plateforme d’investissement à haut rendement',
    'site.brandLine': 'MineMe — Plateforme d’investissement à haut rendement',
    'user.page.investments': 'Investissements',
    'user.page.transactions': 'Transactions',
    'user.page.stopLoss': 'Stop-Loss',
    'user.page.referral': 'Parrainage',
    'user.page.settings': 'Paramètres',
    'user.page.deposit': 'Dépôt',
    'user.page.withdraw': 'Retrait',
    'user.dashboard.title': 'Tableau de bord',
    'user.deposit.title': 'Dépôt',
    'user.withdraw.title': 'Retrait',
    'user.investments.tab.browse': 'Parcourir les plans',
    'user.investments.tab.active': 'Investissements actifs',
    'user.investments.tab.history': 'Historique',
    'user.empty.noStopLoss': 'Aucune protection Stop-Loss active',
    'user.referral.link.title': 'Votre lien de parrainage',
    'user.referral.link.loading': 'Chargement du lien…',
    'user.referral.link.hint': 'Invitez des amis sur MineMe avec votre lien personnel.',
    'user.referral.link.hintLong':
      'Invitez des amis sur MineMe avec votre lien personnel et développez le réseau.',
    'user.referral.link.share': 'Partager',
    'user.referral.link.shareTitle': 'Rejoindre avec mon lien de parrainage',
    'user.referral.stats.direct': 'Filleuls directs',
    'user.referral.stats.indirect': 'Filleuls indirects',
    'user.referral.tree.title': 'Votre réseau de parrainage',
    'user.referral.tree.loading': 'Chargement du réseau…',
    'user.referral.tree.you': 'Vous',
    'user.referral.tree.directLevel': 'Niveau direct',
    'user.referral.tree.indirectLevel': 'Niveau indirect',
    'user.referral.tree.noDirect': 'Pas encore de filleuls directs',
    'user.referral.tree.noIndirect': 'Pas encore de filleuls indirects',
    'user.referral.tree.directCount': '{{n}} filleuls directs',
    'user.referral.tree.indirectCount': '{{n}} filleuls indirects',
    'user.referral.tree.more': '+{{n}} de plus',
    'user.referral.ranking.tableTitle': 'Système de classement',
    'user.referral.ranking.loading': 'Chargement des classements…',
    'user.referral.ranking.loadError':
      'Impossible de charger les classements. Actualisez la page ou réessayez plus tard.',
    'user.referral.ranking.col.rank': 'Rang',
    'user.referral.ranking.col.minDeposit': 'Dépôt min.',
    'user.referral.ranking.col.monthlyIncome': 'Revenu mensuel',
    'user.referral.ranking.col.directRefs': 'Filleuls directs',
    'user.referral.ranking.col.extraCommission': 'Commission supplémentaire',
    'user.referral.ranking.badgeYou': 'Vous',
    'user.referral.rankingRewards.title': 'Récompenses de classement',
    'user.referral.rankingRewards.loading': 'Chargement de la progression du classement…',
    'user.referral.rankingRewards.engineDisabled':
      'Le moteur de récompenses de classement est désactivé par l’administrateur.',
    'user.referral.rankingRewards.notInScope':
      'Les récompenses de classement ne sont pas disponibles pour votre type de compte selon la configuration actuelle.',
    'user.referral.rankingRewards.disqualified':
      'Votre fenêtre d’activation de {{days}} jours a expiré avant d’atteindre le niveau d’entrée ; les récompenses de classement ne sont plus disponibles.',
    'user.referral.rankingRewards.daysLeftOne': 'Il reste {{days}} jour pour activer',
    'user.referral.rankingRewards.daysLeftMany': 'Il reste {{days}} jours pour activer',
    'user.referral.rankingRewards.activationClosingToday': 'La fenêtre d’activation se termine aujourd’hui',
    'user.referral.rankingRewards.activationHint':
      'Atteignez le niveau d’entrée dans les {{days}} jours suivant l’inscription (échéance {{deadline}}). Le jour 1 commence à l’inscription. Les critères directs ET indirects doivent être remplis.',
    'user.referral.rankingRewards.activatedBanner':
      'Activé. Continuez à parrainer pour débloquer des niveaux supérieurs — chacun est attribué une fois lorsque les deux critères sont remplis.',
    'user.referral.rankingRewards.windowBadge': 'Fenêtre de {{days}} jours',
    'user.referral.rankingRewards.earnedSummary': '{{amount}} gagnés sur {{count}} niveau',
    'user.referral.rankingRewards.earnedSummaryPlural': '{{amount}} gagnés sur {{count}} niveaux',
    'user.referral.rankingRewards.col.tier': 'Niveau',
    'user.referral.rankingRewards.col.reward': 'Récompense',
    'user.referral.rankingRewards.col.awarded': 'Attribué',
    'user.referral.currentRank.title': 'Rang actuel',
    'user.referral.currentRank.loading': 'Chargement de votre rang…',
    'user.referral.currentRank.topRank': 'Rang maximal',
    'user.referral.currentRank.targets': 'Objectifs {{rank}}',
    'user.referral.currentRank.topCongratulations': 'Vous avez atteint le rang maximal — félicitations.',
    'user.referral.currentRank.directMore': 'encore {{n}} direct',
    'user.referral.currentRank.directMorePlural': 'encore {{n}} directs',
    'user.referral.currentRank.indirectMore': 'encore {{n}} indirect',
    'user.referral.currentRank.indirectMorePlural': 'encore {{n}} indirects',
    'user.referral.currentRank.readyUnlock': 'Prêt à débloquer {{rank}} lors de la prochaine évaluation.',
    'user.referral.currentRank.remainingJoin': '{{parts}} pour atteindre {{rank}}.',
    'user.referral.currentRank.noTiers': 'Aucun palier de rang configuré',
    'user.referral.currentRank.pillTop': 'Actif — Rang maximal atteint',
    'user.referral.currentRank.pillActive': 'Actif',
    'user.referral.currentRank.pillStarter':
      'Rang de départ — atteignez les objectifs pour obtenir la récompense de palier',
    'user.referral.currentRank.lastReward': 'Dernière récompense de palier :',
    'user.referral.currentRank.bonusHeading': 'Bonus {{rank}}',
    'user.referral.currentRank.progressLine':
      '{{directHave}}/{{directNeed}} directs · {{indirectHave}}/{{indirectNeed}} indirects',
    'user.stopLoss.planType.silver': 'Argent',
    'user.stopLoss.planType.gold': 'Or',
    'user.stopLoss.planType.platinum': 'Platine',
    'user.stopLoss.feature.slotOneInvestment': '1 emplacement pour 1 investissement',
    'user.stopLoss.feature.manualValuationUpdates': 'Mises à jour de valorisation manuelles par l’admin',
    'user.stopLoss.feature.nonRefundableSlot': 'Achat d’emplacement non remboursable',
    'user.stopLoss.feature.flexibleLimits': 'Limites flexibles en % ou montant fixe',
    'user.stopLoss.feature.limitAdjustable': 'Limite ajustable avant déclenchement',
    'user.stopLoss.feature.priorityMonitoring': 'Surveillance prioritaire dans le tableau admin',
    'user.stopLoss.feature.immediateClose': 'Clôture immédiate au franchissement de la limite',
    'user.stopLoss.feature.fixedAmountThreshold': 'Seuil de montant fixe',
    'user.stopLoss.feature.emailAlerts': 'Alertes e-mail',
    'user.stopLoss.feature.manualReview': 'Examen manuel',
    'user.stopLoss.feature.fixedOrPctThreshold': 'Seuil fixe ou en %',
    'user.stopLoss.feature.priorityAlerts': 'Alertes prioritaires',
    'user.stopLoss.feature.autoTrigger': 'Déclenchement automatique',
    'user.stopLoss.feature.autoTriggerReport': 'Déclenchement automatique + rapport',
    'user.stopLoss.feature.advancedThreshold': 'Options de seuil avancées',
    'user.stopLoss.feature.instantAlerts': 'Alertes instantanées',
    'user.stopLoss.feature.legacyBasicDesc': 'Protection essentielle pour débuter',
    'user.stopLoss.feature.legacyStandardDesc': 'Couverture étendue pour les investisseurs actifs',
    'user.stopLoss.feature.legacyFullDesc': 'Protection maximale pour les gros portefeuilles',
    'user.stopLoss.pkg.silver.label': 'Bouclier Argent',
    'user.stopLoss.pkg.silver.desc': 'Protège un investissement avec une limite de baisse modérée.',
    'user.stopLoss.pkg.gold.label': 'Bouclier Or',
    'user.stopLoss.pkg.gold.desc': 'Emplacement stop-loss de niveau supérieur pour une protection baissière renforcée.',
    'user.stopLoss.pkg.platinum.label': 'Bouclier Platine',
    'user.stopLoss.pkg.platinum.desc': 'Emplacement de protection premium pour portefeuilles haut de gamme.',
    'user.stopLoss.pkg.basic.label': 'Protection basique',
    'user.stopLoss.pkg.basic.desc': 'Protection essentielle pour débuter',
    'user.stopLoss.pkg.standard.label': 'Protection standard',
    'user.stopLoss.pkg.standard.desc': 'Couverture étendue pour les investisseurs actifs',
    'user.stopLoss.pkg.full.label': 'Protection complète',
    'user.stopLoss.pkg.full.desc': 'Protection maximale pour les gros portefeuilles',
    'user.stopLoss.yourProtection': 'Votre protection active',
    'user.stopLoss.activePackages': 'Forfaits Stop-Loss actifs',
    'user.stopLoss.live': 'En direct',
    'user.stopLoss.subtitleOne': '1 forfait protège votre portefeuille.',
    'user.stopLoss.subtitleMany': '{{n}} forfaits sont actifs.',
    'user.stopLoss.loadingTable': 'Chargement…',
    'user.stopLoss.emptyDescNoSlots': 'Achetez et assignez un forfait ci-dessous pour protéger vos investissements.',
    'user.stopLoss.emptyDescWaiting': 'Vous avez {{count}} emplacement(s) acheté(s) en attente d’assignation.',
    'user.stopLoss.how.step1Title': 'Acheter un forfait',
    'user.stopLoss.how.step1Desc': 'Choisissez parmi les forfaits à 500 $, 1 200 $ ou 2 000 $',
    'user.stopLoss.how.step2Title': 'Définir le seuil',
    'user.stopLoss.how.step2Desc': 'Définissez un montant fixe en dollars ou une limite de perte en %',
    'user.stopLoss.how.step3Title': 'Surveillance 24/7',
    'user.stopLoss.how.step3Desc': 'Le système surveille en continu la valeur de votre investissement',
    'user.stopLoss.slots.paidPremium': '{{price}} payés · prime {{premium}} %',
    'user.stopLoss.slots.purchasedOn': 'Acheté le {{date}}',
    'user.stopLoss.explainer.title': 'Qu’est-ce que la protection Stop-Loss ?',
    'user.stopLoss.explainer.body':
      'Le stop-loss clôt automatiquement votre investissement si sa valeur passe sous un seuil que vous définissez, protégeant votre capital des baisses brutales et de la volatilité.',
    'user.stopLoss.explainer.badge.nonRefundable': 'Paiement non remboursable',
    'user.stopLoss.explainer.badge.multi': 'Plusieurs forfaits autorisés',
    'user.stopLoss.explainer.badge.monitoring': 'Surveillance automatisée 24/7',
    'user.stopLoss.how.title': 'Comment fonctionne le Stop-Loss',
    'user.stopLoss.how.step4Title': 'Déclenchement auto',
    'user.stopLoss.how.step4Desc': 'L’investissement s’arrête si la valeur franchit votre seuil',
    'user.stopLoss.slots.title': 'Mes emplacements Stop-Loss',
    'user.stopLoss.slots.st.unassigned': 'Non assigné',
  },

  ar: {
    'site.docTitle': '{{page}} | MineMe — منصة استثمار عالية العائد',
    'site.brandLine': 'MineMe — منصة استثمار عالية العائد',
    'user.page.investments': 'الاستثمارات',
    'user.page.transactions': 'المعاملات',
    'user.page.stopLoss': 'وقف الخسارة',
    'user.page.referral': 'الإحالات',
    'user.page.settings': 'الإعدادات',
    'user.page.deposit': 'إيداع',
    'user.page.withdraw': 'سحب',
    'user.dashboard.title': 'لوحة التحكم',
    'user.deposit.title': 'إيداع',
    'user.withdraw.title': 'سحب',
    'user.investments.tab.browse': 'استعراض الخطط',
    'user.investments.tab.active': 'الاستثمارات النشطة',
    'user.investments.tab.history': 'السجل',
    'user.empty.noStopLoss': 'لا يوجد حماية وقف خسارة نشطة',
    'user.referral.link.title': 'رابط الإحالة الخاص بك',
    'user.referral.link.loading': 'جاري تحميل الرابط…',
    'user.referral.link.hint': 'ادعُ الأصدقاء إلى MineMe برابطك الشخصي.',
    'user.referral.link.hintLong': 'ادعُ الأصدقاء إلى MineMe برابطك الشخصي وساعد على نمو الشبكة.',
    'user.referral.link.share': 'مشاركة',
    'user.referral.link.shareTitle': 'انضم عبر رابط الإحالة',
    'user.referral.stats.direct': 'إحالات مباشرة',
    'user.referral.stats.indirect': 'إحالات غير مباشرة',
    'user.referral.tree.title': 'شبكة الإحالة',
    'user.referral.tree.loading': 'جاري تحميل الشبكة…',
    'user.referral.tree.you': 'أنت',
    'user.referral.tree.directLevel': 'المستوى المباشر',
    'user.referral.tree.indirectLevel': 'المستوى غير المباشر',
    'user.referral.tree.noDirect': 'لا إحالات مباشرة بعد',
    'user.referral.tree.noIndirect': 'لا إحالات غير مباشرة بعد',
    'user.referral.tree.directCount': '{{n}} إحالات مباشرة',
    'user.referral.tree.indirectCount': '{{n}} إحالات غير مباشرة',
    'user.referral.tree.more': '+{{n}} أخرى',
    'user.referral.ranking.tableTitle': 'نظام التصنيف',
    'user.referral.ranking.loading': 'جاري تحميل التصنيفات…',
    'user.referral.ranking.loadError': 'تعذر تحميل التصنيفات. حدّث الصفحة أو حاول لاحقاً.',
    'user.referral.ranking.col.rank': 'الرتبة',
    'user.referral.ranking.col.minDeposit': 'حد الإيداع الأدنى',
    'user.referral.ranking.col.monthlyIncome': 'الدخل الشهري',
    'user.referral.ranking.col.directRefs': 'إحالات مباشرة',
    'user.referral.ranking.col.extraCommission': 'عمولة إضافية',
    'user.referral.ranking.badgeYou': 'أنت',
    'user.referral.rankingRewards.title': 'مكافآت التصنيف',
    'user.referral.rankingRewards.loading': 'جاري تحميل تقدم التصنيف…',
    'user.referral.rankingRewards.engineDisabled': 'محرك مكافآت التصنيف معطّل من قبل المسؤول.',
    'user.referral.rankingRewards.notInScope':
      'مكافآت التصنيف غير متاحة لنوع حسابك وفق إعدادات المنصة الحالية.',
    'user.referral.rankingRewards.disqualified':
      'انتهت نافذة التفعيل {{days}} يوماً قبل الوصول إلى مستوى الدخول؛ لم تعد مكافآت التصنيف متاحة.',
    'user.referral.rankingRewards.daysLeftOne': 'بقي {{days}} يوم للتفعيل',
    'user.referral.rankingRewards.daysLeftMany': 'بقي {{days}} يوماً للتفعيل',
    'user.referral.rankingRewards.activationClosingToday': 'نافذة التفعيل تنتهي اليوم',
    'user.referral.rankingRewards.activationHint':
      'حقق مستوى الدخول خلال {{days}} يوماً من التسجيل (الموعد {{deadline}}). اليوم الأول يبدأ عند التسجيل. يجب استيفاء معايير مباشرة وغير مباشرة.',
    'user.referral.rankingRewards.activatedBanner':
      'مفعّل. واصل جذب الإحالات لفتح مستويات أعلى — يُمنح كل مستوى مرة عند استيفاء المعيارين.',
    'user.referral.rankingRewards.windowBadge': 'نافذة {{days}} يوماً',
    'user.referral.rankingRewards.earnedSummary': 'تم ربح {{amount}} عبر {{count}} مستوى',
    'user.referral.rankingRewards.earnedSummaryPlural': 'تم ربح {{amount}} عبر {{count}} مستويات',
    'user.referral.rankingRewards.col.tier': 'المستوى',
    'user.referral.rankingRewards.col.reward': 'المكافأة',
    'user.referral.rankingRewards.col.awarded': 'ممنوحة',
    'user.referral.currentRank.title': 'رتبتك الحالية',
    'user.referral.currentRank.loading': 'جاري تحميل الرتبة…',
    'user.referral.currentRank.topRank': 'أعلى رتبة',
    'user.referral.currentRank.targets': 'أهداف {{rank}}',
    'user.referral.currentRank.topCongratulations': 'لقد بلغت أعلى رتبة — تهانينا.',
    'user.referral.currentRank.directMore': '{{n}} مباشر إضافي',
    'user.referral.currentRank.directMorePlural': '{{n}} مباشرين إضافيين',
    'user.referral.currentRank.indirectMore': '{{n}} غير مباشر إضافي',
    'user.referral.currentRank.indirectMorePlural': '{{n}} غير مباشرين إضافيين',
    'user.referral.currentRank.readyUnlock': 'جاهز لفتح {{rank}} في التقييم القادم.',
    'user.referral.currentRank.remainingJoin': '{{parts}} للوصول إلى {{rank}}.',
    'user.referral.currentRank.noTiers': 'لا توجد مستويات رتبة مُعدّة',
    'user.referral.currentRank.pillTop': 'نشط — أعلى رتبة محققة',
    'user.referral.currentRank.pillActive': 'نشط',
    'user.referral.currentRank.pillStarter': 'رتبة البداية — حقق الأهداف لربح مكافأة المستوى',
    'user.referral.currentRank.lastReward': 'آخر مكافأة مستوى:',
    'user.referral.currentRank.bonusHeading': 'مكافأة {{rank}}',
    'user.referral.currentRank.progressLine':
      '{{directHave}}/{{directNeed}} مباشر · {{indirectHave}}/{{indirectNeed}} غير مباشر',
    'user.stopLoss.planType.silver': 'فضي',
    'user.stopLoss.planType.gold': 'ذهبي',
    'user.stopLoss.planType.platinum': 'بلاتيني',
    'user.stopLoss.feature.slotOneInvestment': 'فتحة واحدة لاستثمار واحد',
    'user.stopLoss.feature.manualValuationUpdates': 'تحديثات تقييم يدوية من المسؤول',
    'user.stopLoss.feature.nonRefundableSlot': 'شراء فتحة غير قابل للاسترداد',
    'user.stopLoss.feature.flexibleLimits': 'حدود مرنة بالنسبة أو بمبلغ ثابت',
    'user.stopLoss.feature.limitAdjustable': 'يمكن تعديل الحد قبل التفعيل',
    'user.stopLoss.feature.priorityMonitoring': 'مراقبة أولوية في لوحة المسؤول',
    'user.stopLoss.feature.immediateClose': 'إغلاق فوري عند تجاوز الحد',
    'user.stopLoss.feature.fixedAmountThreshold': 'عتبة مبلغ ثابت',
    'user.stopLoss.feature.emailAlerts': 'تنبيهات بريد',
    'user.stopLoss.feature.manualReview': 'مراجعة يدوية',
    'user.stopLoss.feature.fixedOrPctThreshold': 'عتبة ثابتة أو بالنسبة',
    'user.stopLoss.feature.priorityAlerts': 'تنبيهات أولوية',
    'user.stopLoss.feature.autoTrigger': 'تفعيل تلقائي',
    'user.stopLoss.feature.autoTriggerReport': 'تفعيل تلقائي + تقرير',
    'user.stopLoss.feature.advancedThreshold': 'خيارات عتبة متقدمة',
    'user.stopLoss.feature.instantAlerts': 'تنبيهات فورية',
    'user.stopLoss.feature.legacyBasicDesc': 'حماية أساسية للمبتدئين',
    'user.stopLoss.feature.legacyStandardDesc': 'تغطية أوسع للمتداولين النشطين',
    'user.stopLoss.feature.legacyFullDesc': 'أقصى حماية للمحافظ الكبيرة',
    'user.stopLoss.pkg.silver.label': 'درع فضي',
    'user.stopLoss.pkg.silver.desc': 'يحمي استثماراً واحداً بحد انخفاض معتدل.',
    'user.stopLoss.pkg.gold.label': 'درع ذهبي',
    'user.stopLoss.pkg.gold.desc': 'فتحة وقف خسارة أعلى مستوى لحماية أقوى من الهبوط.',
    'user.stopLoss.pkg.platinum.label': 'درع بلاتيني',
    'user.stopLoss.pkg.platinum.desc': 'فتحة حماية ممتازة للمحافظ المميزة.',
    'user.stopLoss.pkg.basic.label': 'حماية أساسية',
    'user.stopLoss.pkg.basic.desc': 'حماية أساسية للمبتدئين',
    'user.stopLoss.pkg.standard.label': 'حماية قياسية',
    'user.stopLoss.pkg.standard.desc': 'تغطية أوسع للمتداولين النشطين',
    'user.stopLoss.pkg.full.label': 'حماية كاملة',
    'user.stopLoss.pkg.full.desc': 'أقصى حماية للمحافظ الكبيرة',
    'user.stopLoss.yourProtection': 'حمايتك النشطة',
    'user.stopLoss.activePackages': 'حزم وقف الخسارة النشطة',
    'user.stopLoss.live': 'مباشر',
    'user.stopLoss.subtitleOne': 'حزمة واحدة تحمي محفظتك.',
    'user.stopLoss.subtitleMany': '{{n}} حزم نشطة.',
    'user.stopLoss.loadingTable': 'جاري التحميل…',
    'user.stopLoss.emptyDescNoSlots': 'اشترِ وعيّن حزمة أدناه لحماية استثماراتك.',
    'user.stopLoss.emptyDescWaiting': 'لديك {{count}} فتحة مشتراة بانتظار التعيين.',
    'user.stopLoss.how.step1Title': 'شراء حزمة',
    'user.stopLoss.how.step1Desc': 'اختر من حزم الحماية 500$ أو 1200$ أو 2000$',
    'user.stopLoss.how.step2Title': 'تعيين العتبة',
    'user.stopLoss.how.step2Desc': 'حدد مبلغاً ثابتاً بالدولار أو حداً للخسارة بالنسبة',
    'user.stopLoss.how.step3Title': 'مراقبة 24/7',
    'user.stopLoss.how.step3Desc': 'يراقب النظام قيمة استثمارك باستمرار',
    'user.stopLoss.slots.paidPremium': 'مدفوع {{price}} · علاوة {{premium}}٪',
    'user.stopLoss.slots.purchasedOn': 'تاريخ الشراء {{date}}',
    'user.stopLoss.explainer.title': 'ما هي حماية وقف الخسارة؟',
    'user.stopLoss.explainer.body':
      'يوقف وقف الخسارة استثمارك تلقائياً عندما يهبط السعر دون عتبة تحددها، لحماية رأس المال من تقلبات السوق المفاجئة.',
    'user.stopLoss.explainer.badge.nonRefundable': 'دفع غير قابل للاسترداد',
    'user.stopLoss.explainer.badge.multi': 'يُسمح بعدة حزم',
    'user.stopLoss.explainer.badge.monitoring': 'مراقبة آلية على مدار الساعة',
    'user.stopLoss.how.title': 'كيف يعمل وقف الخسارة',
    'user.stopLoss.how.step4Title': 'تشغيل تلقائي',
    'user.stopLoss.how.step4Desc': 'يتوقف الاستثمار تلقائياً عند تجاوز العتبة',
    'user.stopLoss.slots.title': 'فتحات وقف الخسارة',
    'user.stopLoss.slots.st.unassigned': 'غير معيّن',
  },

  ja: {
    'site.docTitle': '{{page}} | MineMe — 高利回り投資プラットフォーム',
    'site.brandLine': 'MineMe — 高利回り投資プラットフォーム',
    'user.page.investments': '投資',
    'user.page.transactions': '取引',
    'user.page.stopLoss': 'ストップロス',
    'user.page.referral': '紹介',
    'user.page.settings': '設定',
    'user.page.deposit': '入金',
    'user.page.withdraw': '出金',
    'user.dashboard.title': 'ダッシュボード',
    'user.deposit.title': '入金',
    'user.withdraw.title': '出金',
    'user.investments.tab.browse': 'プランを見る',
    'user.investments.tab.active': '運用中の投資',
    'user.investments.tab.history': '履歴',
    'user.empty.noStopLoss': '有効なストップロス保護はありません',
    'user.referral.link.title': 'あなたの紹介リンク',
    'user.referral.link.loading': 'リンクを読み込み中…',
    'user.referral.link.hint': '個人用リンクで友人をMineMeに招待しましょう。',
    'user.referral.link.hintLong': '個人用リンクで友人をMineMeに招待し、ネットワークを広げましょう。',
    'user.referral.link.share': '共有',
    'user.referral.link.shareTitle': '紹介リンクで参加',
    'user.referral.stats.direct': '直接紹介',
    'user.referral.stats.indirect': '間接紹介',
    'user.referral.tree.title': '紹介ネットワーク',
    'user.referral.tree.loading': 'ネットワークを読み込み中…',
    'user.referral.tree.you': 'あなた',
    'user.referral.tree.directLevel': '直接レベル',
    'user.referral.tree.indirectLevel': '間接レベル',
    'user.referral.tree.noDirect': 'まだ直接紹介はありません',
    'user.referral.tree.noIndirect': 'まだ間接紹介はありません',
    'user.referral.tree.directCount': '直接紹介 {{n}} 件',
    'user.referral.tree.indirectCount': '間接紹介 {{n}} 件',
    'user.referral.tree.more': '他 +{{n}}',
    'user.referral.ranking.tableTitle': 'ランキング',
    'user.referral.ranking.loading': 'ランキングを読み込み中…',
    'user.referral.ranking.loadError':
      'ランキングを読み込めませんでした。ページを更新するか、後でもう一度お試しください。',
    'user.referral.ranking.col.rank': '順位',
    'user.referral.ranking.col.minDeposit': '最低入金',
    'user.referral.ranking.col.monthlyIncome': '月間収入',
    'user.referral.ranking.col.directRefs': '直接紹介',
    'user.referral.ranking.col.extraCommission': '追加コミッション',
    'user.referral.ranking.badgeYou': 'あなた',
    'user.referral.rankingRewards.title': 'ランキング報酬',
    'user.referral.rankingRewards.loading': 'ランキング進捗を読み込み中…',
    'user.referral.rankingRewards.engineDisabled': '管理者によりランキング報酬エンジンが無効になっています。',
    'user.referral.rankingRewards.notInScope':
      '現在のプラットフォーム設定では、お客様のアカウント種別ではランキング報酬を利用できません。',
    'user.referral.rankingRewards.disqualified':
      'エントリーレベルに達する前に{{days}}日間の有効化ウィンドウが終了したため、ランキング報酬は利用できません。',
    'user.referral.rankingRewards.daysLeftOne': '有効化まであと{{days}}日',
    'user.referral.rankingRewards.daysLeftMany': '有効化まであと{{days}}日',
    'user.referral.rankingRewards.activationClosingToday': '有効化ウィンドウは本日終了します',
    'user.referral.rankingRewards.activationHint':
      '登録から{{days}}日以内にエントリーレベルに到達してください（期限 {{deadline}}）。初日は登録日からカウント。直接・間接の両条件を満たす必要があります。',
    'user.referral.rankingRewards.activatedBanner':
      '有効化済み。さらに紹介して上位ランクを解除 — 直接・間接の条件を満たすと各段階は一度だけ付与されます。',
    'user.referral.rankingRewards.windowBadge': '{{days}}日ウィンドウ',
    'user.referral.rankingRewards.earnedSummary': '{{count}}段階で{{amount}}を獲得',
    'user.referral.rankingRewards.earnedSummaryPlural': '{{count}}段階で{{amount}}を獲得',
    'user.referral.rankingRewards.col.tier': '段階',
    'user.referral.rankingRewards.col.reward': '報酬',
    'user.referral.rankingRewards.col.awarded': '付与済み',
    'user.referral.currentRank.title': '現在のランク',
    'user.referral.currentRank.loading': 'ランクを読み込み中…',
    'user.referral.currentRank.topRank': '最高ランク',
    'user.referral.currentRank.targets': '{{rank}} の目標',
    'user.referral.currentRank.topCongratulations': '最高ランクに到達しました。',
    'user.referral.currentRank.directMore': 'あと直接{{n}}',
    'user.referral.currentRank.directMorePlural': 'あと直接{{n}}',
    'user.referral.currentRank.indirectMore': 'あと間接{{n}}',
    'user.referral.currentRank.indirectMorePlural': 'あと間接{{n}}',
    'user.referral.currentRank.readyUnlock': '次の評価で{{rank}}の解除準備ができています。',
    'user.referral.currentRank.remainingJoin': '{{rank}}まであと{{parts}}。',
    'user.referral.currentRank.noTiers': 'ランク段階が設定されていません',
    'user.referral.currentRank.pillTop': '有効 — 最高ランク到達',
    'user.referral.currentRank.pillActive': '有効',
    'user.referral.currentRank.pillStarter': 'スタートランク — 目標を達成して段階報酬を獲得',
    'user.referral.currentRank.lastReward': '直近の段階報酬:',
    'user.referral.currentRank.bonusHeading': '{{rank}} ボーナス',
    'user.referral.currentRank.progressLine':
      '直接 {{directHave}}/{{directNeed}} · 間接 {{indirectHave}}/{{indirectNeed}}',
    'user.stopLoss.planType.silver': 'シルバー',
    'user.stopLoss.planType.gold': 'ゴールド',
    'user.stopLoss.planType.platinum': 'プラチナ',
    'user.stopLoss.feature.slotOneInvestment': '1スロットで1投資',
    'user.stopLoss.feature.manualValuationUpdates': '管理者による手動評価更新',
    'user.stopLoss.feature.nonRefundableSlot': 'スロット購入は返金不可',
    'user.stopLoss.feature.flexibleLimits': '％または固定額の柔軟な上限',
    'user.stopLoss.feature.limitAdjustable': '発動前に上限を調整可能',
    'user.stopLoss.feature.priorityMonitoring': '管理画面での優先監視',
    'user.stopLoss.feature.immediateClose': '上限超過で即時クローズ',
    'user.stopLoss.feature.fixedAmountThreshold': '固定金額のしきい値',
    'user.stopLoss.feature.emailAlerts': 'メール通知',
    'user.stopLoss.feature.manualReview': '手動レビュー',
    'user.stopLoss.feature.fixedOrPctThreshold': '固定または％のしきい値',
    'user.stopLoss.feature.priorityAlerts': '優先アラート',
    'user.stopLoss.feature.autoTrigger': '自動発動',
    'user.stopLoss.feature.autoTriggerReport': '自動発動＋レポート',
    'user.stopLoss.feature.advancedThreshold': '高度なしきい値オプション',
    'user.stopLoss.feature.instantAlerts': '即時アラート',
    'user.stopLoss.feature.legacyBasicDesc': '始める方への基本保護',
    'user.stopLoss.feature.legacyStandardDesc': 'アクティブな投資家向けの拡張カバー',
    'user.stopLoss.feature.legacyFullDesc': '大型ポートフォリオ向けの最大保護',
    'user.stopLoss.pkg.silver.label': 'シルバーシールド',
    'user.stopLoss.pkg.silver.desc': '中程度の下落上限で1件の投資を保護します。',
    'user.stopLoss.pkg.gold.label': 'ゴールドシールド',
    'user.stopLoss.pkg.gold.desc': 'より強い下落保護のための上位ストップロス枠。',
    'user.stopLoss.pkg.platinum.label': 'プラチナシールド',
    'user.stopLoss.pkg.platinum.desc': 'プレミアム向けのトップ保護枠。',
    'user.stopLoss.pkg.basic.label': 'ベーシック保護',
    'user.stopLoss.pkg.basic.desc': '始める方への基本保護',
    'user.stopLoss.pkg.standard.label': 'スタンダード保護',
    'user.stopLoss.pkg.standard.desc': 'アクティブな投資家向けの拡張カバー',
    'user.stopLoss.pkg.full.label': 'フル保護',
    'user.stopLoss.pkg.full.desc': '大型ポートフォリオ向けの最大保護',
    'user.stopLoss.yourProtection': '有効な保護',
    'user.stopLoss.activePackages': '有効なストップロスパッケージ',
    'user.stopLoss.live': 'ライブ',
    'user.stopLoss.subtitleOne': '1件のパッケージがポートフォリオを保護しています。',
    'user.stopLoss.subtitleMany': '{{n}}件のパッケージが有効です。',
    'user.stopLoss.loadingTable': '読み込み中…',
    'user.stopLoss.emptyDescNoSlots': '下でパッケージを購入・割り当てて投資を保護してください。',
    'user.stopLoss.emptyDescWaiting': '割り当て待ちの購入済みスロットが{{count}}件あります。',
    'user.stopLoss.how.step1Title': 'パッケージを購入',
    'user.stopLoss.how.step1Desc': '500ドル・1,200ドル・2,000ドルの保護プランから選択',
    'user.stopLoss.how.step2Title': 'しきい値を設定',
    'user.stopLoss.how.step2Desc': '固定ドル金額または％の損失上限を設定',
    'user.stopLoss.how.step3Title': '24時間365日の監視',
    'user.stopLoss.how.step3Desc': 'システムが投資価値を常時監視します',
    'user.stopLoss.slots.paidPremium': '支払済み {{price}} · プレミアム {{premium}}%',
    'user.stopLoss.slots.purchasedOn': '購入日 {{date}}',
    'user.stopLoss.explainer.title': 'ストップロス保護とは？',
    'user.stopLoss.explainer.body':
      'ストップロスは、設定したしきい値を下回ったときに投資を自動で終了し、急落やボラティリティから元本を守ります。',
    'user.stopLoss.explainer.badge.nonRefundable': '返金不可のお支払い',
    'user.stopLoss.explainer.badge.multi': '複数パッケージ可',
    'user.stopLoss.explainer.badge.monitoring': '24時間365日の自動監視',
    'user.stopLoss.how.title': 'ストップロスの仕組み',
    'user.stopLoss.how.step4Title': '自動発動',
    'user.stopLoss.how.step4Desc': '価値がしきい値を超えると投資は自動停止します',
    'user.stopLoss.slots.title': 'マイストップロス枠',
    'user.stopLoss.slots.st.unassigned': '未割当',
  },

  ko: {
    'site.docTitle': '{{page}} | MineMe — 고수익 투자 플랫폼',
    'site.brandLine': 'MineMe — 고수익 투자 플랫폼',
    'user.page.investments': '투자',
    'user.page.transactions': '거래',
    'user.page.stopLoss': '스톱로스',
    'user.page.referral': '추천',
    'user.page.settings': '설정',
    'user.page.deposit': '입금',
    'user.page.withdraw': '출금',
    'user.dashboard.title': '대시보드',
    'user.deposit.title': '입금',
    'user.withdraw.title': '출금',
    'user.investments.tab.browse': '플랜 둘러보기',
    'user.investments.tab.active': '진행 중인 투자',
    'user.investments.tab.history': '내역',
    'user.empty.noStopLoss': '활성 스톱로스 보호가 없습니다',
    'user.referral.link.title': '내 추천 링크',
    'user.referral.link.loading': '링크 불러오는 중…',
    'user.referral.link.hint': '개인 링크로 친구를 MineMe에 초대하세요.',
    'user.referral.link.hintLong': '개인 링크로 친구를 MineMe에 초대하고 네트워크를 키우세요.',
    'user.referral.link.share': '공유',
    'user.referral.link.shareTitle': '추천 링크로 가입',
    'user.referral.stats.direct': '직접 추천',
    'user.referral.stats.indirect': '간접 추천',
    'user.referral.tree.title': '추천 네트워크',
    'user.referral.tree.loading': '네트워크 불러오는 중…',
    'user.referral.tree.you': '나',
    'user.referral.tree.directLevel': '직접 단계',
    'user.referral.tree.indirectLevel': '간접 단계',
    'user.referral.tree.noDirect': '직접 추천이 아직 없습니다',
    'user.referral.tree.noIndirect': '간접 추천이 아직 없습니다',
    'user.referral.tree.directCount': '직접 추천 {{n}}명',
    'user.referral.tree.indirectCount': '간접 추천 {{n}}명',
    'user.referral.tree.more': '+{{n}}명 더',
    'user.referral.ranking.tableTitle': '랭킹',
    'user.referral.ranking.loading': '랭킹 불러오는 중…',
    'user.referral.ranking.loadError':
      '랭킹을 불러올 수 없습니다. 페이지를 새로고침하거나 나중에 다시 시도하세요.',
    'user.referral.ranking.col.rank': '순위',
    'user.referral.ranking.col.minDeposit': '최소 입금',
    'user.referral.ranking.col.monthlyIncome': '월 수입',
    'user.referral.ranking.col.directRefs': '직접 추천',
    'user.referral.ranking.col.extraCommission': '추가 커미션',
    'user.referral.ranking.badgeYou': '나',
    'user.referral.rankingRewards.title': '랭킹 보상',
    'user.referral.rankingRewards.loading': '랭킹 진행 상황 불러오는 중…',
    'user.referral.rankingRewards.engineDisabled': '관리자에 의해 랭킹 보상 엔진이 비활성화되었습니다.',
    'user.referral.rankingRewards.notInScope':
      '현재 플랫폼 설정에 따라 귀하의 계정 유형에서는 랭킹 보상을 사용할 수 없습니다.',
    'user.referral.rankingRewards.disqualified':
      '진입 레벨에 도달하기 전에 {{days}}일 활성화 기간이 만료되어 랭킹 보상을 더 이상 받을 수 없습니다.',
    'user.referral.rankingRewards.daysLeftOne': '활성화까지 {{days}}일 남음',
    'user.referral.rankingRewards.daysLeftMany': '활성화까지 {{days}}일 남음',
    'user.referral.rankingRewards.activationClosingToday': '활성화 기간이 오늘 종료됩니다',
    'user.referral.rankingRewards.activationHint':
      '가입 후 {{days}}일 이내에 진입 레벨에 도달하세요(마감 {{deadline}}). 1일차는 가입일부터입니다. 직접·간접 조건을 모두 충족해야 합니다.',
    'user.referral.rankingRewards.activatedBanner':
      '활성화됨. 더 추천해 상위 등급을 잠금 해제하세요 — 직접·간접 기준을 충족하면 각 단계는 한 번만 지급됩니다.',
    'user.referral.rankingRewards.windowBadge': '{{days}}일 기간',
    'user.referral.rankingRewards.earnedSummary': '{{count}}단계에서 {{amount}} 획득',
    'user.referral.rankingRewards.earnedSummaryPlural': '{{count}}단계에서 {{amount}} 획득',
    'user.referral.rankingRewards.col.tier': '단계',
    'user.referral.rankingRewards.col.reward': '보상',
    'user.referral.rankingRewards.col.awarded': '지급됨',
    'user.referral.currentRank.title': '현재 등급',
    'user.referral.currentRank.loading': '등급 불러오는 중…',
    'user.referral.currentRank.topRank': '최고 등급',
    'user.referral.currentRank.targets': '{{rank}} 목표',
    'user.referral.currentRank.topCongratulations': '최고 등급에 도달했습니다.',
    'user.referral.currentRank.directMore': '직접 {{n}}명 더',
    'user.referral.currentRank.directMorePlural': '직접 {{n}}명 더',
    'user.referral.currentRank.indirectMore': '간접 {{n}}명 더',
    'user.referral.currentRank.indirectMorePlural': '간접 {{n}}명 더',
    'user.referral.currentRank.readyUnlock': '다음 평가에서 {{rank}} 잠금 해제 준비가 되었습니다.',
    'user.referral.currentRank.remainingJoin': '{{rank}}까지 {{parts}}.',
    'user.referral.currentRank.noTiers': '설정된 등급 단계가 없습니다',
    'user.referral.currentRank.pillTop': '활성 — 최고 등급 달성',
    'user.referral.currentRank.pillActive': '활성',
    'user.referral.currentRank.pillStarter': '시작 등급 — 목표를 달성해 단계 보상을 받으세요',
    'user.referral.currentRank.lastReward': '마지막 단계 보상:',
    'user.referral.currentRank.bonusHeading': '{{rank}} 보너스',
    'user.referral.currentRank.progressLine':
      '직접 {{directHave}}/{{directNeed}} · 간접 {{indirectHave}}/{{indirectNeed}}',
    'user.stopLoss.planType.silver': '실버',
    'user.stopLoss.planType.gold': '골드',
    'user.stopLoss.planType.platinum': '플래티넘',
    'user.stopLoss.feature.slotOneInvestment': '1슬롯당 1투자',
    'user.stopLoss.feature.manualValuationUpdates': '관리자 수동 평가 업데이트',
    'user.stopLoss.feature.nonRefundableSlot': '슬롯 구매는 환불 불가',
    'user.stopLoss.feature.flexibleLimits': '유연한 % 또는 고정 한도',
    'user.stopLoss.feature.limitAdjustable': '발동 전 한도 조정 가능',
    'user.stopLoss.feature.priorityMonitoring': '관리자 패널 우선 모니터링',
    'user.stopLoss.feature.immediateClose': '한도 초과 시 즉시 종료',
    'user.stopLoss.feature.fixedAmountThreshold': '고정 금액 임계값',
    'user.stopLoss.feature.emailAlerts': '이메일 알림',
    'user.stopLoss.feature.manualReview': '수동 검토',
    'user.stopLoss.feature.fixedOrPctThreshold': '고정 또는 % 임계값',
    'user.stopLoss.feature.priorityAlerts': '우선 알림',
    'user.stopLoss.feature.autoTrigger': '자동 발동',
    'user.stopLoss.feature.autoTriggerReport': '자동 발동 + 보고서',
    'user.stopLoss.feature.advancedThreshold': '고급 임계값 옵션',
    'user.stopLoss.feature.instantAlerts': '즉시 알림',
    'user.stopLoss.feature.legacyBasicDesc': '초보자를 위한 기본 보호',
    'user.stopLoss.feature.legacyStandardDesc': '활발한 투자자를 위한 확장 커버',
    'user.stopLoss.feature.legacyFullDesc': '대형 포트폴리오를 위한 최대 보호',
    'user.stopLoss.pkg.silver.label': '실버 실드',
    'user.stopLoss.pkg.silver.desc': '중간 하락 한도로 한 건의 투자를 보호합니다.',
    'user.stopLoss.pkg.gold.label': '골드 실드',
    'user.stopLoss.pkg.gold.desc': '더 강한 하락 방어를 위한 상위 스톱로스 슬롯.',
    'user.stopLoss.pkg.platinum.label': '플래티넘 실드',
    'user.stopLoss.pkg.platinum.desc': '프리미엄 포트폴리오용 최상위 보호 슬롯.',
    'user.stopLoss.pkg.basic.label': '기본 보호',
    'user.stopLoss.pkg.basic.desc': '초보자를 위한 기본 보호',
    'user.stopLoss.pkg.standard.label': '스탠다드 보호',
    'user.stopLoss.pkg.standard.desc': '활발한 투자자를 위한 확장 커버',
    'user.stopLoss.pkg.full.label': '풀 보호',
    'user.stopLoss.pkg.full.desc': '대형 포트폴리오를 위한 최대 보호',
    'user.stopLoss.yourProtection': '활성 보호',
    'user.stopLoss.activePackages': '활성 스톱로스 패키지',
    'user.stopLoss.live': '라이브',
    'user.stopLoss.subtitleOne': '1개의 패키지가 포트폴리오를 보호 중입니다.',
    'user.stopLoss.subtitleMany': '{{n}}개의 패키지가 활성입니다.',
    'user.stopLoss.loadingTable': '불러오는 중…',
    'user.stopLoss.emptyDescNoSlots': '아래에서 패키지를 구매·할당해 투자를 보호하세요.',
    'user.stopLoss.emptyDescWaiting': '할당 대기 중인 구매 슬롯이 {{count}}개 있습니다.',
    'user.stopLoss.how.step1Title': '패키지 구매',
    'user.stopLoss.how.step1Desc': '500달러·1,200달러·2,000달러 보호 패키지 중 선택',
    'user.stopLoss.how.step2Title': '임계값 설정',
    'user.stopLoss.how.step2Desc': '고정 달러 금액 또는 % 손실 한도 설정',
    'user.stopLoss.how.step3Title': '24/7 모니터링',
    'user.stopLoss.how.step3Desc': '시스템이 투자 가치를 계속 모니터링합니다',
    'user.stopLoss.slots.paidPremium': '결제 {{price}} · 프리미엄 {{premium}}%',
    'user.stopLoss.slots.purchasedOn': '구매일 {{date}}',
    'user.stopLoss.explainer.title': '스톱로스 보호란?',
    'user.stopLoss.explainer.body':
      '스톱로스는 설정한 임계값 아래로 가치가 떨어지면 투자를 자동으로 종료해 급락과 변동성에서 원금을 보호합니다.',
    'user.stopLoss.explainer.badge.nonRefundable': '환불 불가 결제',
    'user.stopLoss.explainer.badge.multi': '복수 패키지 허용',
    'user.stopLoss.explainer.badge.monitoring': '24시간 자동 모니터링',
    'user.stopLoss.how.title': '스톱로스 작동 방식',
    'user.stopLoss.how.step4Title': '자동 발동',
    'user.stopLoss.how.step4Desc': '가치가 임계값을 넘으면 투자가 자동 중지됩니다',
    'user.stopLoss.slots.title': '내 스톱로스 슬롯',
    'user.stopLoss.slots.st.unassigned': '미할당',
  },

  'zh-CN': {
    'site.docTitle': '{{page}} | MineMe — 高收益投资平台',
    'site.brandLine': 'MineMe — 高收益投资平台',
    'user.page.investments': '投资',
    'user.page.transactions': '交易',
    'user.page.stopLoss': '止损',
    'user.page.referral': '推荐',
    'user.page.settings': '设置',
    'user.page.deposit': '存款',
    'user.page.withdraw': '提现',
    'user.dashboard.title': '控制台',
    'user.deposit.title': '存款',
    'user.withdraw.title': '提现',
    'user.investments.tab.browse': '浏览方案',
    'user.investments.tab.active': '进行中的投资',
    'user.investments.tab.history': '历史',
    'user.empty.noStopLoss': '暂无有效止损保护',
  },

  pt: {
    'site.docTitle': '{{page}} | MineMe — Plataforma de investimento de alto rendimento',
    'site.brandLine': 'MineMe — Plataforma de investimento de alto rendimento',
    'user.page.investments': 'Investimentos',
    'user.page.transactions': 'Transações',
    'user.page.stopLoss': 'Stop-loss',
    'user.page.referral': 'Indicações',
    'user.page.settings': 'Definições',
    'user.page.deposit': 'Depósito',
    'user.page.withdraw': 'Levantamento',
    'user.dashboard.title': 'Painel',
    'user.deposit.title': 'Depósito',
    'user.withdraw.title': 'Levantamento',
    'user.investments.tab.browse': 'Ver planos',
    'user.investments.tab.active': 'Investimentos ativos',
    'user.investments.tab.history': 'Histórico',
    'user.empty.noStopLoss': 'Sem proteção stop-loss ativa',
  },

  it: {
    'site.docTitle': '{{page}} | MineMe — Piattaforma di investimento ad alto rendimento',
    'site.brandLine': 'MineMe — Piattaforma di investimento ad alto rendimento',
    'user.page.investments': 'Investimenti',
    'user.page.transactions': 'Transazioni',
    'user.page.stopLoss': 'Stop-loss',
    'user.page.referral': 'Referral',
    'user.page.settings': 'Impostazioni',
    'user.page.deposit': 'Deposito',
    'user.page.withdraw': 'Prelievo',
    'user.dashboard.title': 'Dashboard',
    'user.deposit.title': 'Deposito',
    'user.withdraw.title': 'Prelievo',
    'user.investments.tab.browse': 'Sfoglia piani',
    'user.investments.tab.active': 'Investimenti attivi',
    'user.investments.tab.history': 'Cronologia',
    'user.empty.noStopLoss': 'Nessuna protezione stop-loss attiva',
  },

  ru: {
    'site.docTitle': '{{page}} | MineMe — инвестиционная платформа с высокой доходностью',
    'site.brandLine': 'MineMe — инвестиционная платформа с высокой доходностью',
    'user.page.investments': 'Инвестиции',
    'user.page.transactions': 'Операции',
    'user.page.stopLoss': 'Стоп-лосс',
    'user.page.referral': 'Рефералы',
    'user.page.settings': 'Настройки',
    'user.page.deposit': 'Депозит',
    'user.page.withdraw': 'Вывод',
    'user.dashboard.title': 'Панель',
    'user.deposit.title': 'Депозит',
    'user.withdraw.title': 'Вывод',
    'user.investments.tab.browse': 'Планы',
    'user.investments.tab.active': 'Активные инвестиции',
    'user.investments.tab.history': 'История',
    'user.empty.noStopLoss': 'Нет активной защиты стоп-лосс',
  },

  bn: {
    'site.docTitle': '{{page}} | MineMe — উচ্চ ফলনশীল বিনিয়োগ প্ল্যাটফর্ম',
    'site.brandLine': 'MineMe — উচ্চ ফলনশীল বিনিয়োগ প্ল্যাটফর্ম',
    'user.page.investments': 'বিনিয়োগ',
    'user.page.transactions': 'লেনদেন',
    'user.page.stopLoss': 'স্টপ-লস',
    'user.page.referral': 'রেফারাল',
    'user.page.settings': 'সেটিংস',
    'user.page.deposit': 'জমা',
    'user.page.withdraw': 'উত্তোলন',
    'user.dashboard.title': 'ড্যাশবোর্ড',
    'user.deposit.title': 'জমা',
    'user.withdraw.title': 'উত্তোলন',
    'user.investments.tab.browse': 'প্ল্যান ব্রাউজ করুন',
    'user.investments.tab.active': 'সক্রিয় বিনিয়োগ',
    'user.investments.tab.history': 'ইতিহাস',
    'user.empty.noStopLoss': 'কোনো সক্রিয় স্টপ-লস সুরক্ষা নেই',
  },

  hi: {
    'site.docTitle': '{{page}} | MineMe — उच्च-प्रतिफल निवेश मंच',
    'site.brandLine': 'MineMe — उच्च-प्रतिफल निवेश मंच',
    'user.page.investments': 'निवेश',
    'user.page.transactions': 'लेनदेन',
    'user.page.stopLoss': 'स्टॉप-लॉस',
    'user.page.referral': 'रेफ़रल',
    'user.page.settings': 'सेटिंग्स',
    'user.page.deposit': 'जमा',
    'user.page.withdraw': 'निकासी',
    'user.dashboard.title': 'डैशबोर्ड',
    'user.deposit.title': 'जमा',
    'user.withdraw.title': 'निकासी',
    'user.investments.tab.browse': 'योजनाएँ देखें',
    'user.investments.tab.active': 'सक्रिय निवेश',
    'user.investments.tab.history': 'इतिहास',
    'user.empty.noStopLoss': 'कोई सक्रिय स्टॉप-लॉस सुरक्षा नहीं',
  },
};
